export default {
    route: {
        dashboard: 'Tauler',
        article: 'Articles',
    },
    month: {
        jan: 'Gener',
        feb: 'Febrer',
        mar: 'Març',
        apr: 'Abril',
        may: 'Maig',
        jun: 'Juny',
        jul: 'Juliol',
        aug: 'Agost',
        sep: 'Setembre',
        oct: 'Octubre',
        nov: 'Novembre',
        dec: 'Desembre',
    },
    week: {
        mon: 'dl',
        tue: 'dt',
        wed: 'dc',
        thu: 'dj',
        fri: 'dv',
        sat: 'ds',
        sun: 'dg',
    },
    navbar: {
        logOut: 'Tancar sessió',
        myProfile: 'El meu perfil ',
        termsConditions: 'Termes i condicions',
    },
    login: {
        title: 'Inici de sessió: ##COMPANY_BRAND_NAME## - Plataforma de serveis eMobility',
        logIn: 'Inici de sessió',
        username: "Nom d'usuari",
        password: 'Contrasenya',
        loginForm: {
            header: 'Benvingut a ##COMPANY_BRAND_NAME##',
        },
        qrCode: {
            header: 'Introdueix el codi del teu autenticador.',
            subheader: 'Introdueix el codi de 6 dígits a continuació per continuar',
            placeholderSecurityCode: 'Introdueix el Codi de Seguretat aquí',
        },
        forgotPassword: {
            header: 'Has oblidat la teva contrasenya?',
            subheader:
                "Introdueix el teu correu electrònic a continuació i t'enviarem un missatge per restablir la teva contrasenya",
            placeholderEmail: 'Introdueix el teu correu electrònic',
        },
        resetPassord: {
            header: 'Restableix la teva contrasenya.',
            subheader: "Introdueix el codi que  t'hem enviat per correu electrònic i restableix la teva contrasenya.",
            placeholder: {
                code: 'Introdueix el teu codi ',
                newPassWord: 'Introdueix la teva nova contrasenya',
                confirmPassWord: 'Torna a confirmar la teva contrasenya',
            },
            success: "La teva contrasenya s'ha restablert amb èxit.",
        },
        button: {
            login: 'Inici de sessió',
            forgotPassword: 'Has oblidat la contrasenya?',
            resetMyPassword: 'Restablir la meva contrasenya',
            submitMyPassword: 'Desa la nova contrasenya',
            back: 'Enrere',
            instavolt: '##COMPANY_BRAND_NAME##',
        },
        label: {
            rememberMe: "Recorda'm",
            password: 'Contrasenya',
            userId: "Identificador d'usuari",
            copyright: 'Copyright ##COMPANY_BRAND_NAME##.',
            showPassword: 'Mostrar contrasenya',
            hidePassword: 'Amagar contrasenya',
        },
        errors: {
            email: {
                email: 'Introdueix una adreça de correu electrònic vàlida.',
                required: 'Introdueix el teu correu electrònic.',
            },
            password: {
                required: 'Introdueix la teva contrasenya. ',
                max: 'La contrasenya ha de tenir com a mínim 8 caràcters',
            },
            securityCode: {
                required: 'Introdueix el teu codi de seguretat.',
                max: 'El codi de seguretat ha de tenir com a mínim 6 caràcters',
            },
            verificationCodeInvalid: 'Codi de verificació no vàlid.',
            generalError: 'Error en processar la teva sol·licitud.',
            incorrectCredentials: "Nom d'usuari o contrasenya incorrectes.",
            defaultPasswordExpired: 'La teva contrasenya ha caducat i ha de ser restablerta per un administrador.',
            inValidEmailAddress: "L'adreça de correu electrònic no és vàlida.",
            securityCodeInvalid: 'Codi de seguretat no vàlid.',
            verificationCodeFormat: 'Introdueix el codi de verificació de 6 dígits.',
            passwordFormat:
                'La contrasenya ha de tenir més de 15 caràcters, amb almenys una lletra majúscula, una lletra minúscula, un caràcter especial i un número.',
            confirmPasswordMatch: 'La contrasenya i la confirmació de contrasenya no coincideixen.',
            common: 'Alguna cosa ha anat malament, si us plau, intenta-ho de nou.',
        },
        toast: {
            error: 'Alguna cosa ha anat malament, si us plau, intenta-ho de nou.',
        },
    },
    dashboard: {
        title: 'Inici: ##COMPANY_BRAND_NAME## - Plataforma de serveis eMobility',
        header: 'Tauler',
        formtitle: 'Validació de formulari',
        label: {
            pending: 'Pendent ',
            currentBalance: 'Saldo actual',
            closingBalance: 'Saldo a tancar',
            availableCredit: 'Crèdit disponible',
            unbilledAmount: 'Import no facturat',
            filter: 'Filtrar',
            reportTags: "Etiquetes d'informe",
            driverGroup: 'Grups de conductors',
            selectDriverGroup: 'Selecciona els grups de conductors',
            selectTags: 'Selecciona les etiquetes ',
            dateRange: 'Rang de dates ',
            month: 'Mes',
            year: 'Any',
            day: 'Dia',
            week: 'Setmana',
            userSessionTitle: 'Sessions del conductor ',
            userSessions: 'Sessions del conductor ',
            expenseTitle: 'Suma despeses ',
            expense: 'Despesa',
            energyTitle: "Suma d'energia (kWh) ",
            enrgy: 'Energia ',
            averageTransationTitle: 'Transaccions mitjanes',
            transaction: 'Transacció ',
            creditLimit: 'Límit de crèdit ',
            totalDriverAccounts: 'Comptes totals del conductor',
            enabled: 'Habilitat',
            disabled: 'Deshabilitat',
        },
        button: {
            apply: 'Aplicar',
            clear: 'Netejar',
        },
        cpoType: {
            Both: 'Ambdós',
            Local: 'Local',
            International: 'Internacional',
        },
    },
    permission: {
        createArticle: 'Afegir article',
        editArticle: "Edita l'article",
        save: 'Desa',
        confirm: 'Estàs segur?',
        cancel: 'Cancel·lar ',
        update: 'Actualitzar',
    },
    table: {
        pagination: {
            prev: 'Anterior',
            nrev: 'Següent',
            showing: 'Mostrant',
        },
        data: {
            noData: "No s'han trobat dades.",
        },
    },
    article: {
        title: 'Gestionar Article',
        id: "Identificador de l'Article",
        date: 'Data',
        tabletitle: 'Títol',
        author: 'Autor',
        reviewer: 'Revisor',
        actions: 'Accions',
        saveMessage: 'Article guardat amb èxit',
        updateMessage: 'Article actualitzat amb èxit',
        deleteMessage: 'Article eliminat amb èxit',
    },
    user: {
        title: 'Usuaris: ##COMPANY_BRAND_NAME## - Plataforma de serveis eMobility',
        user: 'Usuaris',
        manageUser: 'Gestionar usuari',
        placeholder: {
            name: 'Nom',
            email: 'Adreça de correu electrònic',
            phoneNo: 'Núm Telèfon.',
            firstName: 'Nom',
            lastName: 'Cognom',
            userGroup: "Grups d'usuaris",
            userRoles: "Rols d'usuari",
            Organisation: 'Organització',
            select: "Selecciona l'estat",
            selectOrganisation: "Selecciona l'organització",
            selectUserGroup: "Selecciona el grup d'usuaris",
            languagePreference: "Preferència d'idioma",
        },
        label: {
            firstName: 'Nom',
            lastName: 'Cognom',
            email: 'Correu electrònic',
            phoneNo: 'Núm Telèfon.',
            optional: '(Opcional)',
            userGroups: "Grups d'usuaris",
            userRoles: "Rols d'usuari",
            Organisation: 'Organització',
            createdDate: 'Data de creació',
            languagePreference: "Preferència d'idioma",
            id: 'Id',
            action: 'Acció',
            status: 'Estat',
            name: 'Nom',
            delete: 'Eliminar',
            enable: 'Habilitar',
            all: 'Tots',
            disable: 'Deshabilitar',
            enabled: 'Habilitat',
            disabled: 'Deshabilitat',
            pending: 'Pendent',
            reset2FA: 'Restablir 2FA',
            deleted: 'Esborrat',
            lastLoginDate: "Data de l'últim inici de sessió",
        },
        button: {
            search: 'Cercar',
            cancel: 'Cancel·lar',
            save: 'Desa',
            add: 'Afegir',
            edit: 'Editar',
            reset: 'Restablir',
            delete: 'Eliminar',
            yes: 'Sí',
            no: 'No',
            enabled: 'Habilitar',
            disabled: 'Deshabilitar',
            action: 'Acció',
            back: 'Enrere',
            sendEmail: 'Envia un correu electrònic',
            reset2FA: 'Restablir 2FA',
        },
        message: {
            deleteConfirmMesage: 'Estàs segur que el vols eliminar?',
            enableConfirmMesage: 'Estàs segur que el vols habilitar?',
            disableConfirmMesage: 'Estàs segur que el vols deshabilitar?',
            sendMailConfirmMessage: 'Estàs segur que vols enviar un correu electrònic?',
            mailSentSuccessMessage: 'Correu electrònic enviat amb èxit.',
            reset2FAConfirmMesage: 'Estàs segur que vols restablir 2FA per a aquest usuari?',
        },
        errors: {
            email: {
                required: 'Introdueix una adreça de correu electrònic.',
                email: 'Introdueix una adreça de correu electrònic vàlida.',
            },
            firstName: {
                required: 'Introdueix nom',
                valid: 'Introdueix nom vàlid',
            },
            lastName: {
                required: 'Introdueix cognom',
                valid: 'Introdueix cognom vàlid',
            },
            phoneNo: {
                required: 'Introdueix número de telèfon',
                match: 'Introdueix número de telèfon vàlid',
            },
            userGroups: {
                required: "Selecciona almenys un grup d'usuaris",
            },
            organization: {
                required: "Selecciona l'organització",
            },
        },
    },
    userGroup: {
        title: "Grups d'usuari: ##COMPANY_BRAND_NAME## - Plataforma de serveis eMobility",
        manageUserGroup: "Gestionar el grup d'usuaris",
        users: 'Usuaris',
        header: "Grups d'usuaris",
        button: {
            search: 'Cercar',
            reset: 'Restablir',
            edit: 'Editar',
            delete: 'Eliminar',
            save: 'Desa',
            cancel: 'Cancel·lar',
            yes: 'Sí',
            no: 'No',
            action: 'Acció',
            add: 'Afegir',
            back: 'Enrere',
            enable: 'Habilitar',
            disable: 'Deshabilitar',
            permission: "Permís d'accés",
        },
        placeholder: {
            groupName: 'Nom del grup',
            users: 'Selecciona usuaris',
            select: "Selecciona l'estat",
            organisation: "Selecciona l'organització",
        },
        message: {
            deleteConfirmMesageForOrganistion:
                "En eliminar aquest grup d'organització, eliminarem l'associació del grup amb una organització concreta. Estàs segur que vols continuar?",
            deleteConfirmMesage: 'Estàs segur que el vols eliminar?',
            enableConfirmMesage: 'Estàs segur que el vols habilitar?',
            disableConfirmMesage: 'Estàs segur que el vols deshabilitar?',
        },
        label: {
            id: 'Id',
            name: 'Nom',
            description: 'Descripció',
            Organisation: 'Organització',
            createdBy: 'Creat per',
            status: 'Estat',
            modifiedBy: 'Modificat per',
            createdDate: 'Data de creació',
            modifiedDate: 'Data de modificació',
            action: 'Acció',
            groupName: 'Nom del grup',
            delete: 'Eliminar',
            enable: 'Habilitar',
            disable: 'Deshabilitar',
            phoneNo: 'Número de telèfon',
            email: 'Adreça de correu electrònic',
            groupAccess: 'Accés del grup',
            selectUsers: 'Selecciona usuaris',
            enabled: 'Habilitat ',
            disabled: 'Deshabilitat',
            yes: 'Sí',
            no: 'No',
        },
        form: {
            groupName: {
                label: 'Nom del grup',
                placeholder: 'Introdueix el nom del grup',
            },
            description: {
                label: 'Descripció',
                placeholder: 'Introdueix la descripció',
            },
            Organisation: {
                label: 'Organització',
            },
        },
        errors: {
            groupName: {
                required: 'Introdueix un nom de grup',
                valid: 'Introdueix un nom de grup vàlid',
                max: 'Màxim 50 caràcters permesos',
            },
            description: {
                max: 'Màxim 255 caràcters permesos',
            },
            userList: {
                required: 'Selecciona almenys un usuari',
            },
        },
        permission: {
            header: 'Permís',
            label: {
                module: 'Mòdul',
                subModule: 'Submòdul',
                action: 'Acció',
            },
        },
    },
    transactions: {
        headerTitle:
            'Transaccions del conductor - ##COMPANY_BRAND_NAME##: Càrrega ràpida de vehicles elèctrics al Regne Unit',
        title: 'Transaccions del conductor',
        transaction: 'Transacció ',
        columns: {
            amount: 'Import',
            location: 'Ubicació',
            date: 'Data',
            milesAdded: 'Milles afegides',
            time: 'Temps',
            cost: 'Cost',
            energy: 'Energia',
            action: 'Acció',
            remark: 'Observacions',
            credit: 'Crèdit',
            debit: 'Dèbit',
            closing: 'Tancament',
            transaction: 'Identificador de transacció',
            name: 'Nom',
            type: 'Tipus',
            federatedAccount: 'Tipus de compte federat',
            reference_id: 'Identificador de referencia',
            energyCost: "Cost de l'energia",
            fixedCost: 'Cost fix',
            chargingTimeCost: 'Cost del temps de càrrega',
            parkingTime: "Temps d'aparcament",
            parkingCost: "Cost d'aparcament",
            appliedTariff: 'Tarifa Aplicada',
            netCost: 'Cost net',
            VATRate: "Tipus d'IVA",
        },
        form: {
            charge: 'Carregant',
            payment: 'Pagament',
            month: 'Mes',
        },
        label: {
            exportAll: 'Exporta-ho tot',
            driver: 'Conductor',
            vehicle: 'Vehicle',
            cardPayment: 'Pagament amb targeta',
            referralBonus: 'Bonus de referència',
            rewards: 'Recompenses',
            transactionDetails: 'Detalls de la transacció',
            transaction_id: 'Identificador de transacció',
            fullName: 'Nom complet',
            email: 'Correu electrònic',
            phone_number: 'Número de telèfon',
            viewFailedPayments: 'Veure els pagaments fallits',
        },
        button: {
            search: 'Cercar',
            reset: 'Restablir',
            back: 'Enrere',
        },
        placeholder: {
            startDate: "Data d'inici",
            endDate: 'Data de finalització',
            name: 'Nom',
            chargingStation: 'Estació de càrrega',
            selectType: 'Selecciona el tipus',
            transaction: 'Identificador de transacció',
            reference_id: 'Identificador de referencia',
        },
        message: {
            noDataToExport: 'No hi ha dades per exportar.',
            error: {
                common: 'Alguna cosa ha anat malament. Si us plau, intenta-ho de nou.',
            },
        },
    },
    driver: {
        title: 'Conductors: ##COMPANY_BRAND_NAME## - Plataforma de serveis eMobility',
        header: 'Conductors',
        manageDriver: 'Gestionar el conductor',
        startCharge: 'Inicia la càrrega remota',
        activities: 'Activitats',
        detail: 'Detalls del conductor',
        address_detail: 'Adreça',
        billing_address_detail: 'Adreça de facturació',
        chargeDetails: 'Detalls de la càrrega',
        debtLetterHistory: 'Històric de cartes de deute',
        note: 'Nota: Si la recompensa existent del conductor és diferent de la nova promoció, llavors els seus volts actuals caducaran.',
        charityAdded: 'Donatiu a la caritat afegit',
        cd: 'cd',
        placeholder: {
            name: 'Nom',
            email: 'Adreça de correu electrònic',
            firstName: 'Nom',
            lastName: 'Cognom',
            payment_card: 'Últims 4 dígits de la targeta de pagament',
            select: {
                status: "Selecciona l'estat",
                account_type: 'Selecciona el tipus de compte',
                payment_type: 'Selecciona el tipus de pagament',
                driver_groups: 'Selecciona els grups de conductors',
                driver_tags: 'Selecciona les etiquetes ',
                organization: "Selecciona l'organització",
                promotion: 'Selecciona la promoció',
            },
            driverGroup: 'Grups de conductors',
            organization: 'Organització',
            account_type: 'Tipus de compte',
            payment_type: 'Tipus de pagament',
            referral_code: 'Codi de referència',
            driver_tags: 'Etiquetes',
            address: 'Adreça línia 1',
            address2: 'Adreça línia 2',
            city: 'Ciutat',
            county: 'Comtat',
            postal_code: 'Codi postal',
            billing_address: 'Adreça línia 1',
            billing_address2: 'Adreça línia 2',
            billing_city: 'Ciutat',
            billing_county: 'Comtat',
            billing_postal_code: 'Codi postal',
            promotion: 'Promocions',
            currentDriverPromotion: 'Promoció actual',
            driverPromotionJoinDate: "Data d'adhesió",
            chargeLocation: 'Ubicació',
            chargeStation: 'Estació',
            connector: 'Connector',
            limitedKWH: 'kWh limitats:',
            confirmationNote:
                "Per raons de seguretat del compte, confirma el nom i cognom del conductor, l'adreça línia 1 i el codi postal abans de començar la càrrega remota. Marca la casella després de la confirmació del client",
            rfidCard: 'Targeta RFID',
            confirmationNoteFleet: 'Confirma aquesta contrasenya amb el conductor: ',
            vehicle_number: 'Número del vehicle',
            api_url: "URL de l'API",
            startDate: "Data d'inici",
            endDate: 'Data de finalització',
            publicRFID: 'Identificador de la targeta RFID pública',
            languagePreference: "Preferència d'idioma",
            searchAddress: 'Adreça',
        },
        label: {
            firstName: 'Nom',
            lastName: 'Cognom',
            email: 'Correu electrònic',
            group: 'Grup',
            driverGroups: 'Grups de conductors',
            driver_tags: 'Etiquetes',
            organization: 'Organització',
            payment_type: 'Tipus de pagament',
            referral_code: 'Codi de referència',
            createdDate: 'Data de creació',
            id: 'Id',
            action: 'Acció',
            status: 'Estat',
            account_type: 'Tipus de compte',
            type: 'Tipus',
            name: 'Nom',
            delete: 'Eliminar',
            enable: 'Habilitar',
            all: 'Tots',
            disable: 'Deshabilitar',
            enabled: 'Habilitat ',
            disabled: 'Deshabilitat',
            cancelled: 'Cancel·lat',
            deleted: 'Esborrat',
            address: 'Adreça',
            address2: 'Adreça línia 2',
            city: 'Ciutat',
            county: 'Comtat',
            postal_code: 'Codi postal',
            billing_address: 'Adreça línia 1',
            billing_address2: 'Adreça línia 2',
            billing_city: 'Ciutat',
            billing_county: 'Comtat',
            billing_postal_code: 'Codi postal',
            promotion: 'Promocions',
            expired: ' - Caducat',
            currentDriverPromotion: 'Promoció actual',
            driverPromotionJoinDate: "Data d'adhesió",
            vehicleNumber: 'Número del vehicle',
            paymentCard: 'Targeta de pagament',
            cardType: 'Tipus de targeta',
            cardNumber: 'Targeta núm. (Últims 4 dígits)',
            cardTitle: 'Títol de la targeta',
            cardExpiry: 'Data de venciment de la targeta',
            paymentServiceProvider: 'Proveïdor de serveis de pagament',
            viewReferral: 'Visualitza la referència',
            referralDetails: 'Detalls de la referència',
            referrer_name: 'Nom del referent',
            referral_name: 'Nom de la referència',
            referral_bonus: 'Bonus de referència',
            referralBonusStatus: 'Estat del bonus de referència',
            referee_Name: 'Nom del revisor',
            noRecords: 'No hi ha registres a mostrar',
            noReferralsMessage: 'Sense referències',
            referrerName: 'Nom del referent del revisor: ',
            referralCode: 'Codi de referència del referent:',
            noReferrerMessage: 'Sense referent',
            current_balance: 'Saldo actual',
            referral_balance: 'Saldo de referència',
            account_balance: 'Saldo del compte',
            rewards_balance: 'Saldo de recompenses',
            balanceDetails: 'Detalls del saldo',
            pending_transactions_details: 'Detalls de les Transaccions Pendents',
            pending_balance: 'Saldo Pendent',
            federated_account_type: 'Tipus de compte federat',
            pending: 'Pendent',
            rfidCard: 'Targeta RFID',
            startCharge: 'Inicia la càrrega remota',
            chargeLocation: 'Ubicació',
            chargeStation: 'Estació',
            connector: 'Connector',
            limitedKWH: 'kWh limitats:',
            confirmationNote:
                "Per raons de seguretat del compte, confirma el nom i cognom del conductor, l'adreça línia 1 i el codi postal abans de començar la càrrega remota. Marca la casella després de la confirmació del client",
            fullName: 'Nom complet',
            phoneNo: 'Número de telèfon',
            confirmationNoteFleet: 'Confirma aquesta contrasenya amb el conductor: ',
            chargingStartedMessage: "Sol·licitud d'inici de càrrega remota realitzada amb èxit",
            resetPassword: 'Restablir la contrasenya',
            password: 'Contrasenya',
            disablePaymentCard: 'Deshabilitar la targeta de pagament',
            requestedData: 'Dades sol·licitades',
            apiURL: 'API',
            viewData: 'Veure dades',
            deletionEmailSent: "Correu electrònic d'eliminació del compte enviat",
            yes: 'Sí',
            onstop: 'En aturar',
            badDebtor: 'Mal deutor',
            available: 'Disponible',
            languagePreference: "Preferència d'idioma",
            fakeAccount: 'Compte fals',
            addNotes: 'Afegir notes',
            newNote: 'Nova nota',
            addNote: 'Afegir nota',
            existingNotes: 'Notes existents',
            viewNotes: 'Veure notes',
            notes: 'Notes',
            financialDetails: 'Detalls financers',
            uniqueID: 'Identificador únic',
            dateGenerated: 'Data de generació',
            debtValue: 'Valor del deute',
            letterTemplate: 'Plantilla de carta utilitzada',
            lastCardValidationDate: 'Data de la última validació de la targeta',
            cancelPendingTransactions: 'Cancel·la Les Transaccions Pendents',
            cancelTransactions: 'Cancel·lar Transaccions',
        },
        pendingTransaction: {
            label: {
                chargeLocation: 'Ubicació',
                chargeStation: 'Estació de Càrrega',
                sessionId: 'ID de Sessió',
                sessionStatus: 'Estat de la Sessió',
                amount: 'Import',
                createdDate: 'Data de Creació',
            },
            button: {
                settle: 'Liquidar',
                cancel: 'Cancel·lar',
            },
        },
        account_type: {
            driver: 'Conductor',
            vehicle: 'Vehicle',
        },
        payment_type: {
            credit_account: 'Compte de crèdit ',
            prepayment_account: 'Compte de prepagament',
        },
        button: {
            search: 'Cercar',
            cancel: 'Cancel·lar',
            save: 'Desa',
            edit: 'Editar',
            reset: 'Restablir',
            delete: 'Eliminar',
            yes: 'Sí',
            no: 'No',
            enabled: 'Habilitar',
            disabled: 'Deshabilitar',
            action: 'Acció',
            back: 'Enrere',
            sendEmail: 'Envia un correu electrònic',
            viewTransactions: 'Veure transaccions',
            close: 'Tancar',
            startCharge: 'Inicia la càrrega remota',
            startChargeBtn: 'Inicia la càrrega',
            resetPassword: 'Restablir la contrasenya',
            submit: 'Enviar',
            amendBalance: 'Modifica el saldo',
            viewActivities: 'Veure activitats',
            premiumSubscriptions: 'Subscripcions premium',
            markAsFake: 'Marca com a compte fals',
            addNotes: 'Afegir notes',
            debtLetterHistory: 'Històric de cartes de deute',
            enableReferralCode: 'Activa el codi de referència',
            disableReferralCode: 'Deshabilita el codi de referència',
        },
        message: {
            deleteConfirmMesage: 'Estàs segur que el vols eliminar?',
            enableConfirmMesage: 'Estàs segur que el vols habilitar?',
            disableConfirmMesage: 'Estàs segur que el vols deshabilitar?',
            sendMailConfirmMessage: 'Estàs segur que vols enviar un correu electrònic?',
            mailSentSuccessMessage: 'Correu electrònic enviat amb èxit.',
            resetPasswordConfirmMesage: "Estàs segur que vols restablir la contrasenya d'aquest usuari?",
            deleteDriverConfirmMesage: "Estàs segur que vols eliminar el compte d'aquest conductor?",
            markAsFakeConfirmMessage:
                'Vols marcar aquest compte de conductor com a fals? Aquest és un procés unidireccional on la informació es esborrada.',
            enableReferralCodeConfirmMesage:
                'Estàs segur que vols habilitar el Codi de Referència per a aquest conductor?',
            disableReferralCodeConfirmMesage:
                'Estàs segur que vols desactivar el Codi de Referència per a aquest conductor? ',
            cancelPendingTransactionsConfirmMesage:
                'Esteu segur que voleu cancel·lar les transaccions pendents seleccionades?',
        },
        errors: {
            driverGroups: {
                required: 'Selecciona almenys un Grup de Conductors.',
            },
            organization: {
                required: "Selecciona l'organització",
            },
            tag: {
                invalid_fromat: "Caràcters no vàlids a l'etiqueta",
            },
            fullName: {
                valid: 'Introdueix un nom vàlid',
            },
            phoneNo: {
                match: 'Introdueix número de telèfon vàlid',
            },
            email: {
                required: 'Introdueix una adreça de correu electrònic.',
                email: 'Introdueix una adreça de correu electrònic vàlida.',
            },
            password: {
                passwordFormat:
                    'La contrasenya ha de tenir més de 10 caràcters, amb almenys una lletra majúscula, una lletra minúscula, un caràcter especial i un número.',
            },
        },
    },
    driverGroup: {
        title: 'Grups de conductors: ##COMPANY_BRAND_NAME## - Plataforma de serveis eMobility',
        titleFleet: 'Grups: ##COMPANY_BRAND_NAME## - Plataforma de serveis eMobility',
        manageDriverGroup: 'Gestionar el grup de conductors',
        manageDriverGroupFleet: 'Gestionar el grup',
        driversList: 'Conductors',
        driversListFleet: 'Conductors/Vehicles',
        header: 'Grups de conductors',
        headerFleet: 'Grups',
        button: {
            search: 'Cercar',
            reset: 'Restablir',
            edit: 'Editar',
            delete: 'Eliminar',
            save: 'Desa',
            cancel: 'Cancel·lar',
            yes: 'Sí',
            no: 'No',
            action: 'Acció',
            add: 'Afegir',
            back: 'Enrere',
            enable: 'Habilitar',
            disable: 'Deshabilitar',
        },
        placeholder: {
            groupName: 'Nom del grup',
            drivers: 'Selecciona els conductors',
            driversFleet: 'Selecciona conductors/vehicles',
            select: "Selecciona l'estat",
            selectType: 'Selecciona el tipus',
        },
        message: {
            deleteConfirmMesage: 'Estàs segur que el vols eliminar?',
            enableConfirmMesage: 'Estàs segur que el vols habilitar?',
            disableConfirmMesage: 'Estàs segur que el vols deshabilitar?',
        },
        label: {
            id: 'Id',
            name: 'Nom',
            description: 'Descripció',
            organization: 'Organització',
            createdBy: 'Creat per',
            status: 'Estat',
            modifiedBy: 'Modificat per',
            createdDate: 'Data de creació',
            modifiedDate: 'Data de modificació',
            action: 'Acció',
            groupName: 'Nom del grup',
            delete: 'Eliminar',
            enable: 'Habilitar',
            disable: 'Deshabilitar',
            phoneNo: 'Número de telèfon',
            email: 'Adreça de correu electrònic',
            groupAccess: 'Accés del grup',
            selectDrivers: 'Selecciona els conductors',
            selectDriversFleet: 'Selecciona conductors/vehicles',
            enabled: 'Habilitat ',
            disabled: 'Deshabilitat',
            yes: 'Sí',
            no: 'No',
            vehicle_number: 'Vehicle núm.',
            type: 'Tipus',
            updateDriverAssociation: "Actualitzar l'Associació del Conductor",
            addToThisGroup: 'Afegir a aquest grup',
            cancel: 'Cancel·lar',
        },
        form: {
            groupName: {
                label: 'Nom del grup',
                placeholder: 'Introdueix el nom del grup',
            },
            description: {
                label: 'Descripció',
                placeholder: 'Introdueix la descripció',
            },
        },
        errors: {
            groupName: {
                required: 'Introdueix un nom de grup',
                valid: 'Introdueix un nom de grup vàlid',
                max: 'Màxim 50 caràcters permesos',
            },
            description: {
                max: 'Màxim 255 caràcters permesos',
            },
            driverList: {
                required: 'Si us plau, selecciona almenys un conductor',
                requiredfleet: 'Si us plau, selecciona almenys un conductor/vehicle',
            },
            spendLimit: {
                valid: 'Si us plau, introdueix almenys un valor límit de despesa',
            },
        },
    },
    vat: {
        title: 'IVA: ##COMPANY_BRAND_NAME##',
        vat: 'IVA',
        manageVat: "Gestionar l'IVA",
        label: {
            name: 'Nom',
            description: 'Descripció',
            rate: 'Taxa',
            createdDate: 'Data de creació',
            action: 'Acció',
            status: 'Estat',
            disabled: 'Deshabilitat',
            enabled: 'Habilitat ',
            delete: 'Eliminar',
            enable: 'Habilitar',
            disable: 'Deshabilitar',
            defaultVAT: 'IVA per defecte',
            yes: 'Sí',
        },
        message: {
            deleteConfirmMesage: 'Estàs segur que el vols eliminar?',
            enableConfirmMesage: 'Estàs segur que el vols habilitar?',
            disableConfirmMesage: 'Estàs segur que el vols deshabilitar?',
            setDefaultConfirmMesage: 'Estàs segur que vols establir aquest IVA per defecte?',
        },
        button: {
            search: 'Cercar',
            cancel: 'Cancel·lar ',
            save: 'Desa',
            add: 'Afegir',
            edit: 'Editar',
            reset: 'Restablir',
            delete: 'Eliminar',
            enabled: 'Habilitar',
            disabled: 'Deshabilitar',
            action: 'Acció',
            back: 'Enrere',
            setDefaultVAT: 'establir com a Predeterminat',
        },
        placeholder: {
            select: "Selecciona l'estat",
            name: 'Nom',
            description: 'Descripció',
            rate: 'Taxa',
        },
        errors: {
            name: {
                valid: 'Introdueix un nom vàlid.',
            },
            rate: {
                max: 'La taxa no pot ser superior al 100',
                min: 'La taxa no pot ser inferior a 0',
                number: 'La taxa ha de ser un número',
            },
            description: {
                valid: 'Introdueix una descripció vàlida',
            },
        },
    },
    confirmBox: {
        button: {
            yes: 'Sí',
            no: 'No',
            proceed: 'Procedir',
            cancel: 'Cancel·lar',
        },
    },
    tag: {
        title: 'Etiquetes: ##COMPANY_BRAND_NAME## - Plataforma de serveis eMobility',
        tag: 'Etiquetes',
        manageUser: 'Gestionar usuaris',
        placeholder: {
            name: "Nom de l'etiqueta",
            select: 'Seleccionar',
        },
        label: {
            name: "Nom de l'etiqueta",
            driver_count: 'Nombre de conductors',
            charge_location_count: 'Nombre de punts de càrrega',
            action: 'Acció',
            delete: 'Eliminar',
            editHeader: "Edita l'etiqueta",
        },
        button: {
            search: 'Cercar',
            cancel: 'Cancel·lar',
            save: 'Desa',
            add: 'Afegir',
            edit: 'Editar',
            reset: 'Restablir',
            delete: 'Eliminar',
            yes: 'Sí',
            no: 'No',
            enabled: 'Habilitar',
            disabled: 'Deshabilitar',
            action: 'Acció',
            back: 'Enrere',
        },
        message: {
            deleteConfirmMesage:
                "S'eliminarà l'etiqueta de tots els conductors associats i del lloc de càrrega vinculat. Estàs segur que el vols eliminar?",
        },
        errors: {
            name: "Caràcters no vàlids a l'etiqueta",
        },
    },
    chargeStation: {
        title: 'Estacions de càrrega: ##COMPANY_BRAND_NAME## - Plataforma de serveis eMobility',
        chargeStations: 'Estacions de càrrega',
        manageVat: "Gestionar l'estació de càrrega",
        label: {
            modifiedDate: 'Data de modificació',
            importChargeStationHeader: "Importar l'estació de càrrega ",
            csvFile: 'Fitxer CSV',
            manageAmenities: 'Gestionar Serveis',
            chargePoint: 'Punt de càrrega',
            allLocations: 'Totes Ubicacions',
            assignedLocation: 'Ubicació assignada',
            unassignedLocation: 'Ubicació sense assignar',
            chargeLocation: {
                cp_id: 'CP-Id',
                type: 'Tipus',
                name: 'Nom',
                locationName: 'Nom de la ubicació',
                address: 'Adreça',
                city: 'Ciutat',
                postal_code: 'Codi postal',
                appliesToOrg: "S'aplica a l'organització",
                associatedPromotion: 'Promoció associada',
                gmbLocationId: 'Identificador de ubicació de GMB',
                override_tariff: 'Sobreescriure tarifa',
                cpo: 'CPO',
            },
            chargeStation: {
                uid: 'UId',
                evse_id: "Identificador d'EVSE",
                status: 'Estat',
                physicalReference: 'Referència física',
                city: 'Ciutat',
                postal_code: 'CodiPostal',
            },
            stationConnector: {
                connector_id: 'Identificador de connector',
                standard: 'Estàndard',
                format: 'Format com a tipus',
                power_type: 'Tipus de corrent',
                voltage: 'Voltatge',
                amperage: 'Amperatge',
                power_rating: 'Classificació de potència',
                override_tariff: 'Sobreescriure tarifa',
            },
            selectTag: 'Selecciona les etiquetes',
            addTagHeader: 'Associar etiquetes',
            tags: 'Etiquetes',
            yes: 'Sí',
            assignedTariff: 'Assignar tarifa',
            assignTariff: 'Assignar tarifa a les ubicacions',
            delete: 'Eliminar',
            action: 'Acció',
            addPromotion: 'Afegir promoció',
            selectPromotion: 'Selecciona la promoció',
            exportChargeStations: {
                connector_id: 'connector_id',
                max_power: 'max_power',
                cp_id: 'cp_id',
                type: 'tipus',
                location: 'ubicació',
                station_name: 'station_name',
                address: 'adreça',
                city: 'ciutat',
                postal_code: 'postal_code',
                country: 'país',
                latitude: 'latitud',
                longitude: 'longitud',
                evse_id: 'evse_id',
                standard: 'estàndard',
                format: 'format',
                powertype: 'powertype',
                voltage: 'voltatge',
                amperage: 'amperatge',
            },
            gmbLocationID: 'Identificador de ubicació de GMB',
            clickHere: 'Feu clic aquí',
            downloadTemplate: 'per descarregar la plantilla',
            importStationsModel: "Importar el model d'estacions de càrrega",
            noDataToExport: 'No hi ha dades per exportar.',
            note: 'Nota: ',
            autoCalculateMaxPowerNote:
                'Algunes CPO han estat configurades per calcular automàticament la potència màxima; utilitzant aquesta importació podria sobreescriure aquests valors calculats.',
            applyToOrg: "Aplicar a tota l'organització",
        },
        errors: {
            tag: {
                invalid_fromat: "Caràcters no vàlids a l'etiqueta",
            },
            file: {
                fileType: "Es poden carregar arxius amb extensió '.csv'.",
            },
            gmbLocationId: {
                valid: 'Introdueix un identificador de ubicació de GMB vàlida',
            },
            common: 'Alguna cosa ha anat malament. Intenta-ho de nou',
        },
        button: {
            search: 'Cercar',
            reset: 'Restablir',
            save: 'Desa',
            cancel: 'Cancel·lar',
            edit: 'Editar',
            expand: 'Ampliar ',
            collapse: 'Reduir',
            import: 'Importar',
            synchronize: 'Sincronitzar',
            syncStation: 'Sincronitzar estació',
            assignTariff: 'Assignar tarifa',
            delete: 'Eliminar',
            add: 'Afegir',
            addSelected: 'Afegir seleccionats',
            addAll: 'Afegir tot',
            yes: 'Sí',
            no: 'No',
            back: 'Enrere',
            apply: 'Aplicar',
            editGMBLocationID: 'Editar identificador de ubicació de GMB',
            downloadLocationsData: 'Extreure dades de ubicacions de càrrega',
            exportAll: 'Exporta-ho tot',
            importStationsModel: "Importar el model d'estacions de càrrega",
            deleteSelected: 'Eliminar seleccionats',
            export: 'Exportar',
            viewAssociatedTariffs: 'Veure tarifes associades',
        },
        placeholder: {
            selectStationStatus: "Selecciona l'estat",
            name: 'Nom',
            cp_id: 'CP-Id',
            tags: 'Etiquetes',
            address: 'Adreça',
            selectTag: "Selecciona l'etiqueta",
            evse_id: "Identificador d'EVSE",
            selectChargePoint: 'Selecciona CPOs',
            selectRegion: 'Selecciona la regió',
            selectPromotion: 'Selecciona la promoció',
            gmbLocationID: 'Identificador de ubicació de GMB',
            selectPowerType: 'Selecciona el tipus de corrent',
            selectAppliedTariff: 'Selecciona Tarifa Aplicada',
        },
        message: {
            deleteConfirmMesage: 'Estàs segur que el vols eliminar?',
            addPromotion: 'Detalls de la promoció actualitzats amb èxit',
            updateAmenitiesSuccess: "Serveis d'ubicació de càrrega actualitzats amb èxit",
            chargePointRequire: 'Es requereix com a mínim un punt de càrrega',
            deleteBulkConfirmMessage: 'Estàs segur que vols eliminar els registres seleccionats?',
            applyToAllOrgConfirmMessage:
                'Vols aplicar aquesta tarifa també a les organitzacions per a totes les ubicacions? ',
        },
        manageAmenities: 'Gestionar Serveis',
        chargeStationTariffDetailsModal: {
            header: 'Detalls de la tarifa',
            tabsName: {
                general: 'General',
            },
        },
    },
    chargeStationMap: {
        title: 'Vista del mapa de les estacions de càrrega: ##COMPANY_BRAND_NAME## - Plataforma de serveis eMobility',
        header: 'Estacions de càrrega',
        label: {
            address: 'Adreça',
            backOfficeUrl: 'URL del Back Office:',
            amenities: 'Serveis:',
            satellite: 'Satèl·lit',
            map: 'Mapa',
            search: 'Cercar',
            refresh: 'Actualitzar',
            apply: 'Aplicar',
            clear: 'Netejar',
            loading: 'Carregant...',
        },
        placeholder: {
            locationSearch: 'Buscar estació',
            mapSearch: 'Cerca pel nom del carrer, ciutat o codi postal',
        },
    },
    promotionsRequest: {
        headerTitle:
            'Sol·licitud de promocions per a conductors - ##COMPANY_BRAND_NAME## - Plataforma de serveis eMobility',
        title: 'Sol·licitud de promocions per a conductors',
        promotionsRequest: 'Promocions sol·licitades',
        columns: {
            driverName: 'Nom del conductor',
            promotionsName: 'Nom de la promoció',
            promotionsCode: 'Codi',
            approved: 'Estat',
            approvedBy: 'Modificat per',
            approvedDate: 'Data de modificació',
            action: 'Acció',
            email: 'Correu electrònic',
        },
        form: {
            charge: 'Carregant',
            payment: 'Pagament',
            month: 'Mes',
        },
        label: {
            approved: 'Aprovat',
            pending: 'Pendent ',
            rejected: 'Rebutjat',
            modelHeader: 'Promoció sol·licitada - ',
            enterComment: 'Introdueix els teus comentaris',
        },
        button: {
            search: 'Cercar',
            reset: 'Restablir',
            back: 'Enrere',
            approved: 'Aprovar',
            pending: 'Pendent ',
            rejected: 'Rebutjar',
            action: 'Acció',
            edit: 'Editar',
        },
        placeholder: {
            driverName: 'Nom del conductor',
            promotionsName: 'Nom de la promoció',
            promotionsCode: 'Codi',
            select: "Selecciona l'estat",
        },
        message: {
            ManagestatusMesage:
                "Feu clic a Aprovat o Rebutjat per aplicar l'estat de la sol·licitud. Un cop s'hagi actualitzat aquesta sol·licitud, ja no es podrà editar.",
        },
    },
    driverAccountBalance: {
        title: 'Saldo del compte del conductor: ##COMPANY_BRAND_NAME## - Plataforma de serveis eMobility',
        driverAccountBalance: 'Saldo del compte del conductor',
        manageUser: 'Gestionar el saldo del compte del conductor',
        placeholder: {
            name: 'Nom/Correu electrònic',
            select: "Selecciona l'estat",
            payment_type: 'Selecciona el tipus de pagament',
            description: 'Comentari',
            amount: " Introduïu l'import a Crèdit/Dèbit",
        },
        label: {
            name: 'Nom',
            email: 'Correu electrònic',
            payment_type: 'Tipus de pagament',
            driver_status: 'Estat del compte',
            current_balance: 'Saldo',
            currency: 'Moneda',
            driver_id: 'Identificador del conductor',
            action: 'Acció',
            delete: 'Eliminar',
            refundHeader: 'Retirada',
            creditPayment: 'Compte de crèdit',
            prePayment: 'Compte de prepagament',
            enabled: 'Habilitat ',
            disabled: 'Deshabilitat',
            refund: 'Esmenar saldo del compte',
            description: 'Comentari',
            amount: " Introduïu l'import a Crèdit/Dèbit",
            additional_payment: 'Pagament addicional',
            payment_refunds: 'Retirades de pagament',
            payment_settlement: 'Modificació de saldo - Sol·licitud',
            balance: 'Tipus de saldo',
            accountBalance: 'Fons del compte',
            referralBonus: 'Bonus de referència',
            rewardBalance: 'Saldo de recompensa',
            total_balance: 'Saldo total',
            rewards: 'Recompenses',
            pendingBalance: 'Saldo Pendent',
        },
        button: {
            search: 'Cercar',
            cancel: 'Cancel·lar ',
            save: 'Desa',
            add: 'Afegir',
            edit: 'Editar',
            reset: 'Restablir',
            delete: 'Eliminar',
            yes: 'Sí',
            no: 'No',
            enabled: 'Habilitar',
            disabled: 'Deshabilitar',
            action: 'Acció',
            back: 'Enrere',
            send_for_approval: 'Enviar per a aprovació',
        },
        message: {
            deleteConfirmMesage:
                "S'eliminarà l'etiqueta de tots els conductors associats i del lloc de càrrega vinculat. Estàs segur que el vols eliminar?",
        },
        errors: {
            name: "Caràcters no vàlids a l'etiqueta",
            amount: {
                moreThan: "L'import ha de ser més gran/més petit que 0",
                maxcredit: 'Límit màxim assolit per al crèdit del compte',
                maxdebit: 'Límit màxim assolit per al dèbit del compte',
            },
        },
    },
    driverPromotions: {
        title: 'Gestionar promoció: ##COMPANY_BRAND_NAME## - Plataforma de serveis eMobility',
        manageDriverPromotion: 'Gestionar promoció',
        driverPromotions: 'Promocions',
        label: {
            name: 'Nom',
            code: 'Codi',
            errorMessage: "Missatge d'error",
            used: 'Utilitzat',
            unUsed: 'No utilitzat',
            uploadFileErrorMessage: 'Errors en pujar codis promocionals.',
            updatePromotionCode: 'Actualitzar codi de promoció',
            unique_code: 'Codi únic',
            uniquePromotionCode: 'Codis de promoció',
            importDriverPromotionCodeHeader: 'Importar codis de promoció del conductor',
            csvFile: 'Codis de promoció',
            promotionCode: 'Codi de promoció',
            usedBy: 'Utilitzat per',
            description: 'Descripció',
            accountCredit: 'Crèdit del compte',
            discountRatePeriod: 'Període de taxa de descompte',
            indays: '(Dies)',
            intilakWhRate: 'Tarifa inicial kWh',
            ivRewardsPromotion: 'Promoció IV Rewards',
            referralPromotion: 'Promoció de referència',
            expiryDate: 'Data de caducitat',
            needApprovalToJoinPromotion: "Necessitat d'aprovació per unir-se a la promoció",
            newDriversOnly: 'Només nous conductors',
            forOrganisation: "Per a l'organització",
            createdDate: 'Data de creació',
            action: 'Acció',
            status: 'Estat',
            delete: 'Eliminar',
            enable: 'Habilitar',
            disable: 'Deshabilitar',
            enabled: 'Habilitat ',
            disabled: 'Deshabilitat',
            deleted: ' (Eliminat)',
            csvFileSupported: "Només s'admeten fitxers CSV",
            clickHere: 'Feu clic aquí',
            downloadTemplate: 'per descarregar la plantilla',
            exportColumnHeder: 'promotion_codes',
            min_kwh_package_promotion: 'KWh mínim',
            package_promotion_period: 'Període de promoció del paquet (Dies)',
            package_promotion_volt_bonus: 'Nombre de volts recompensats',
            rfidCardUnitPrice: 'Preu unitari de la targeta RFID',
            subscription: 'Subscripció premium',
            tariffUpdate: 'Actualització de tarifes',
            currentTariff: 'Tarifa de sobreescriptura actual',
            next: 'Següent',
            newTariff: 'Nova tarifa de sobreescriptura',
            save: 'Desa',
            override_tariff: 'Sobreescriure tarifa',
            manageOverrideTariff: 'Gestionar la Tarifa de substitució',
        },
        placeholder: {
            name: 'Nom',
            promotionCode: 'Codi de promoció',
            selectTariff: 'Selecciona la tarifa',
            selectStatus: "Selecciona l'estat",
            startDate: "Data d'inici",
            endDate: 'Data de finalització',
            forOrganisation: "Per a l'organització",
            min_kwh_package_promotion: 'KWh mínim',
            package_promotion_period: 'Període de promoció del paquet',
            package_promotion_volt_bonus: 'Nombre de volts recompensats',
            rfidCardUnitPrice: 'Preu unitari de la targeta RFID',
            premium_subscription: 'Subscripció premium',
            selectCurrentTariff: 'Selecciona la tarifa de sobreescriptura actual',
            selectNewTariff: 'Selecciona la nova tarifa de sobreescriptura',
            selectOverrideTariff: 'Seleccioneu la Tarifa de substitució',
        },
        button: {
            update: 'Actualitzar',
            import: 'Importar',
            search: 'Cercar',
            cancel: 'Cancel·lar',
            save: 'Desa',
            add: 'Afegir',
            edit: 'Editar',
            reset: 'Restablir',
            delete: 'Eliminar',
            enable: 'Habilitar',
            disable: 'Deshabilitar',
            action: 'Acció',
            back: 'Enrere',
        },
        message: {
            deleteConfirmMesage: 'Estàs segur que el vols eliminar?',
            enableConfirmMesage: 'Estàs segur que el vols habilitar?',
            disableConfirmMesage: 'Estàs segur que el vols deshabilitar?',
            subscriptionChangeWarningMessage:
                'Advertència: Canviar el tipus de subscripció resultarà en la cancel·lació de tots els renovaments automàtics associats al compte del Conductor.',
            tariffUpdateNote: "La nova tarifa s'assignarà a les següents promocions:",
            updateTariffConfirmMessage:
                'Estàs segur que vols actualitzar la tarifa per a les promocions seleccionades?',
            selectOneRecord: "Selecciona com a mínim una promoció per a l'actualització de la tarifa",
        },
        errors: {
            promotionName: {
                valid: 'Introdueix un nom de promoció vàlid',
            },
            promotionCode: {
                valid: 'Introdueix un codi de promoció vàlid',
            },
            accountCredit: {
                moreThan: 'El crèdit del compte ha de ser més gran que 0',
                max: 'Límit màxim assolit per al crèdit del compte',
                typeError: 'Introdueix una quantitat de crèdit del compte vàlida',
            },
            discountRatePeriod: {
                moreThan: 'El període de taxa de descompte ha de ser més gran que 0',
            },
            intialRate: {
                max: 'La taxa no pot ser superior al 100',
                min: 'La taxa no pot ser inferior a 0',
                typeError: 'Introdueix una taxa vàlida',
            },
            common: 'Alguna cosa ha anat malament, si us plau, intenta-ho de nou.',
            file: {
                fileType: "Es poden carregar arxius amb extensió '.csv'.",
            },
            maxValue: 'El valor màxim no pot excedir 2147483647',
            rfidCardUnitPrice: {
                max: 'El preu unitari de la targeta RFID no pot ser superior a 1000',
            },
        },
    },
    paymentApproval: {
        headerTitle:
            'Aprovacions del saldo del compte - ##COMPANY_BRAND_NAME##: Càrrega ràpida de vehicles elèctrics al Regne Unit',
        title: 'Aprovacions del saldo del compte',
        transaction: 'Transacció ',
        columns: {
            email: 'Correu electrònic',
            amount: 'Import',
            status: 'Estat',
            request_by: 'Sol·licitat per',
            request_date: 'Sol·licitat en',
            request_by_comment: 'Solicitada per Comentaris',
            review_by: 'Revisada per',
            review_date: 'Revisada en',
            review_comment: 'Comentaris del revisor',
            credit: 'Crèdit',
            debit: 'Dèbit',
            closing: 'Tancament',
            transaction: 'Identificador de transacció',
            name: 'Nom',
            action: 'Acció',
            request_type: 'Tipus de sol·licitud',
            invoice: 'Factura',
        },
        form: {
            driver: 'Conductor',
            organisation: 'Organització',
            month: 'Mes',
        },
        label: {
            request_type: 'Tipus de sol·licitud',
            refundHeader: 'Modificació de saldo',
            pending: 'Pendent',
            approved: 'Aprovar',
            declined: 'Rebutjar',
            approve: 'Aprovar',
            decline: 'Rebutjar',
            comment: 'Introdueix els teus comentaris',
            status: 'Estat',
            refund: 'Aprovar crèdit/dèbit',
            refundAmount: 'Import de retirada ',
            commentsFrom: 'Comentaris de',
        },
        button: {
            search: 'Cercar',
            reset: 'Restablir',
            back: 'Enrere',
            save: 'Desa',
            cancel: 'Cancel·lar ',
        },
        placeholder: {
            comment: 'Introdueix els teus comentaris',
            status: "Selecciona l'estat",
            name: 'Nom/Correu electrònic',
            refundAmount: 'Import de retirada ',
        },
        message: {
            noDataToExport: 'No hi ha dades per exportar.',
            selectApprovalOrReject: 'Aprova/rebutja aquesta sol·licitud.',
        },
    },
    paymentScheduleSetting: {
        title: "Configuració de l'horari de pagament: ##COMPANY_BRAND_NAME## - Plataforma de serveis eMobility ",
        header: 'Horari de pagament',
        note: ' Programa una tasca en segon pla per liquidar les factures pendents de la càrrega de vehicles elèctrics realitzada pels conductors.',
        placeholder: {
            day_of_week: 'Dia de la setmana',
        },
        label: {
            daily: 'Diari',
            weekly: 'Setmanal',
            day_of_week: 'Dia de la setmana',
            selectDay: 'Selecciona el dia',
        },
        day_of_week: {
            monday: 'DIMARTS',
            tuesday: 'DIMECRES',
            wednesday: 'DIJOUS',
            thursday: 'DIVENDRES',
            friday: 'DISSABTE',
            saturday: 'DIUMENGE',
            sunday: 'DILLUNS',
        },
        button: {
            save: 'Desa',
        },
    },
    paymentFailures: {
        title: 'Errors en els pagaments: ##COMPANY_BRAND_NAME## - Plataforma de serveis eMobility',
        managePaymentFailures: 'Errors en els pagaments',
        placeholder: {
            name: 'Nom/Correu electrònic',
            note: 'Observació',
            startDate: "Data d'inici",
            endDate: 'Data de finalització',
            select: "Selecciona l'estat",
            status: "Selecciona l'estat",
            failureReason: "Motiu de l'error",
        },
        label: {
            name: 'Nom',
            email: 'Correu electrònic',
            transaction_id: 'Identificador de transacció',
            total_amount: 'Import total',
            currency_name: 'Moneda',
            created_date: 'Data de creació',
            status: 'Estat',
            note: 'Observació',
            action: 'Acció',
            editHeader: "Actualitza l'estat de pagament",
            pending: 'Pendent ',
            acknowledged: 'Reconegut',
            closed: 'Tancat',
            transactionDetails: 'Detalls de la transacció',
            transaction_request: 'Sol·licitud de transacció',
            transaction_response: 'Resposta de la transacció',
            error_message: "Missatge d'error",
            error_code: "Codi d'error",
            request_type: 'Tipus de sol·licitud',
            response_code: 'Codi de resposta',
            response_code_description: 'Descripció del codi de resposta',
            null_data: 'Sense dades',
            transaction_date: 'Data de la transacció',
            failureReason: "Motiu de l'error",
        },
        button: {
            search: 'Cercar',
            cancel: 'Cancel·lar',
            save: 'Desa',
            add: 'Afegir',
            edit: "Edita l'estat",
            reset: 'Restablir',
            yes: 'Sí',
            no: 'No',
            action: 'Acció',
            back: 'Enrere',
        },
    },
    chargeTariff: {
        title: 'Tarifes: ##COMPANY_BRAND_NAME## - Plataforma de serveis eMobility',
        header: 'Tarifes',
        tariff: 'Tarifa',
        columns: {
            location: 'Ubicació',
            chargeStation: "Nom de l'estació de càrrega",
            connector: 'Connector',
            standard: 'Estàndard',
        },
        label: {
            name: 'Nom',
            vat_name: " Nom de l'IVA",
            vat_rate: 'Taxa (%)',
            vat_description: 'Descripció',
            cpo_id: 'Identificador del cpo',
            action: 'Acció',
            url: 'URL',
            currency: 'Moneda',
            createdDate: 'Data de creació',
            status: 'Estat',
            enabled: 'Habilitat ',
            deleted: 'Eliminat',
            detail: 'Detall',
            promotions: 'Promocions',
            lastUpdated: 'Darrera actualització el',
            promotionCode: 'Codi de promoció',
            description: 'Descripció',
            expiryDate: 'Data de caducitat',
            priceComponents: 'Components del preu',
            priceComponent: 'Component del preu',
            type: 'TIPUS',
            price: 'PREU',
            pricePerHour: 'Preu (per hora)',
            restriction: 'Restricció',
            startDate: "Data d'Inici",
            startTime: "Hora d'inici",
            endDate: 'Data de finalització',
            endTime: 'Hora de finalització',
            minkWh: 'KWh mínim',
            maxkWh: 'KWh màxim',
            minPower: 'Potència Mínima',
            maxPower: 'Potència Màxima',
            minDuration: 'Durada Mín',
            maxDuration: 'Durada Màx',
            weekDays: 'Dies de la setmana',
            selectVat: "Selecciona l'IVA",
            attachVat: "Adjunta l'IVA",
            vatdetail: "Detall de l'IVA",
            editVAT: "Edita el tipus d'IVA",
            vatType: "Tipus d'IVA",
            tariffID: 'Identificador de la tarifa',
            element: 'ELEMENT',
            prices: 'Preus',
            restrictions: 'Restriccions',
            stepSize: 'GRANULARITAT',
            vat: 'IVA',
            date: 'DATA',
            time: 'HORA',
            kwh: 'KWH',
            power: 'POTÈNCIA (KW)',
            duration: 'DURADA (SEC)',
            current: 'CORRENT (AMP)',
            maxCurrent: 'Corrent Màxim',
            minCurrent: 'Corrent Mínim',
            restrictionTitle: 'RESTRICCIÓ',
            details: 'Detalls',
            weekDaysTitle: 'DIES DE LA SETMANA',
            maxKwhTitle: 'KWH Màxim',
            minKwhTitle: 'KWH Mínim',
            accessGroups: "Grups d'accés",
            locations: 'Ubicacions',
            CPOs: 'CPOs',
            connectors: 'Connectors',
        },
        placeholder: {
            name: 'Nom',
            selectStatus: "Selecciona l'estat",
            selectVat: "Selecciona l'IVA",
            selectType: "Selecciona el tipus d'IVA",
            tariffID: 'ID de la tarifa',
            vatType: "Tipus d'IVA",
            currency: 'Moneda',
        },
        button: {
            search: 'Cercar',
            reset: 'Restablir',
            action: 'Acció',
            edit: 'Editar',
            detail: 'Detall',
            add: 'Afegir',
            back: 'Enrere',
            save: 'Desa',
            cancel: 'Cancel·lar',
            editvat: "Adjunta l'IVA",
            editVAT: "Edita el tipus d'IVA",
            groupRestrictions: 'Restriccions de Tarifa de Grup',
            ungroupRestrictions: 'Restriccions de Tarifa No Agrupada',
        },
        noRestrictionAvailable: 'Cap Restricció Disponible',
    },
    partnerPromotion: {
        title: 'Promocions de socis: ##COMPANY_BRAND_NAME## - Plataforma de serveis eMobility',
        header: 'Promocions de socis',
        placeholder: {
            nameorcompany: 'Nom o empresa',
            status: "Selecciona l'estat",
            date_from: "Data d'inici",
            date_to: 'Data de finalització',
        },
        label: {
            name: 'Nom',
            company: 'Empresa',
            description: 'Descripció',
            date_from: "Data d'inici",
            date_to: 'Data de finalització',
            expiry_date: 'Data de caducitat',
            created_date: 'Data de creació',
            status: 'Estat',
            action: 'Acció',
            enabled: 'Habilitat',
            disabled: 'Deshabilitat',
            delete: 'Eliminar',
        },
        button: {
            search: 'Cercar',
            cancel: 'Cancel·lar',
            add: 'Afegir',
            save: 'Desa',
            edit: 'Editar',
            reset: 'Restablir',
            delete: 'Eliminar',
            yes: 'Sí',
            no: 'No',
            enabled: 'Habilitar',
            disabled: 'Deshabilitar',
            action: 'Acció',
            back: 'Enrere',
            enable: 'Habilitar',
            disable: 'Deshabilitar',
            chargeStation: 'Estacions de càrrega',
            preview: 'Visualització prèvia',
        },
        message: {
            deleteConfirmMesage: 'Estàs segur que el vols eliminar?',
            enableConfirmMesage: 'Estàs segur que el vols habilitar?',
            disableConfirmMesage: 'Estàs segur que el vols deshabilitar?',
        },
        insert: {
            header: 'Gestiona les Promocions del Col·laborador',
            placeholder: {
                name: 'Nom',
                company: "Informació de l'empresa",
                description: 'Descripció',
                start_date: "Data d'inici",
                expiry_date: 'Data de caducitat',
                offer_duration: '60 minuts',
                stored_for_future_use_days: '2 dies',
                qr_code_details: 'Informació del codi QR',
                certificate: 'Certificat',
                image: "Imatge de l'oferta",
                image1: 'Imatge addicional 1',
                image2: 'Imatge addicional 2',
                image3: 'Imatge addicional 3',
                image4: 'Imatge addicional 4',
                image5: 'Imatge addicional 5',
                banner_image: 'Logotip de la promoció',
                locationPageImage: 'Imatge de la pàgina de la ubicació',
                displayOnChargeLocation: 'Mostra a la pantalla la ubicació de càrrega',
                promotion_button_text: 'Text del botó de la promoció  ',
            },
            label: {
                name: 'Nom',
                company: 'Empresa',
                description: 'Descripció',
                start_date: "Data d'inici",
                expiry_date: 'Data de caducitat',
                offer_duration: "Durada de l'oferta (minuts)",
                stored_for_future_use_days: 'Desa per a ús futur (dies)',
                always_display_on_partner_promotion: 'Mostra sempre la promoció del col·laborador',
                qr_code_details: 'Codi QR',
                certificate: 'Certificat',
                image: "Imatge de l'oferta",
                banner_image: 'Logotip de la promoció (1030 X 430)',
                layout: 'Disposició de la pantalla',
                note1: 'Cal tenir en compte que has de mencionar <strong>##image##</strong> i <strong>##qrcode##</strong> al codi HTML de la disposició de la pantalla per substituir les dades corresponents. Es poden afegir imatges addicionals a la disposició utilitzant el codi ##image0X##, on X pot variar de 1 a 5.',
                qr_code_note:
                    'Cal tenir en compte que has de mencionar <strong>##ChargeTransID##</strong>, <strong>##StartChargeTS##</strong>, <strong>##ChargeStationID##</strong> i <strong>##ChargeStationAddress##</strong> al codi QR per substituir les dades corresponents.',
                locationPageImage: 'Imatge de la pàgina de la ubicació',
                displayOnChargeLocation: 'Mostra a la pantalla la ubicació de càrrega',
                partner_promotion_display_type: 'Tipus de visualització de la promoció',
                promotion_button_text: 'Text del botó de la promoció',
                open_external_url: 'Obre una URL externa',
                external_url: 'URL externa',
                image1: 'Imatge addicional 1',
                image2: 'Imatge addicional 2',
                image3: 'Imatge addicional 3',
                image4: 'Imatge addicional 4',
                image5: 'Imatge addicional 5',
            },
            errors: {
                common: 'Alguna cosa ha anat malament, intenta-ho de nou.',
                name: {
                    valid: 'Introdueix un nom de promoció vàlid',
                    max: 'El nom de la promoció és massa llarg',
                },
                description: {
                    max: 'La descripció de la promoció és massa llarga',
                },
                offer_duration: {
                    moreThan: "La durada de l'oferta ha de ser superior a 0",
                    max: "La durada de l'oferta no pot ser superior a 60 minuts",
                },
                stored_for_future_use_days: {
                    moreThan: "Els dies emmagatzemats per a l'ús futur han de ser superiors a 0",
                    max: "Els dies emmagatzemats per a l'ús futur no poden ser superiors a 99 dies",
                },
                banner_image: {
                    dimensions: 'El logotip de la promoció ha de ser de 1030 X 430 dimensions',
                },
                image: {
                    fileType: "Es poden carregar arxius amb extensió '.jpg', '.png', '.svg', '.jpeg'",
                    location_page_image: 'La imatge de la pàgina de la ubicació és un camp obligatori',
                },
                certificate: {
                    fileType: "Es poden carregar arxius amb extensió '.crt', '.cer'",
                },
                promotion_button_text: {
                    valid: 'Introdueix un text de botó de promoció vàlid',
                },
                external_url: {
                    url: 'La URL externa ha de ser una URL vàlida',
                },
            },
        },
        assign: {
            header: 'Estacions de càrrega',
            headerModal: 'Estació de càrrega',
            placeholder: {
                name: 'Introdueix el nom',
                locationName: 'Introdueix el nom de la ubicació',
                address: 'Adreça',
                tags: 'Selecciona les etiquetes',
            },
            label: {
                add: 'Afegir',
                name: 'Nom',
                type: 'Tipus',
                address: 'Adreça',
                city: 'Ciutat',
                postcode: 'Codi postal',
                last_updated: 'Data de modificació',
                action: 'Acció',
                delete: 'Eliminar',
            },
            button: {
                delete: 'Eliminar',
            },
            message: {
                deleteConfirmMesage: 'Estàs segur que el vols eliminar?',
            },
        },
    },
    CPOInterface: {
        title: 'Comptes: ##COMPANY_BRAND_NAME## - Plataforma de serveis eMobility',
        header: 'Comptes',
        placeholder: {
            name: 'Nom',
            status: "Selecciona l'estat",
        },
        label: {
            name: 'Nom',
            party_id: 'Identificador de la part',
            country_code: 'Codi del país',
            version_url: 'URL de la versió',
            created_date: 'Data de creació',
            status: 'Estat',
            action: 'Acció',
            enabled: 'Habilitat ',
            disabled: 'Deshabilitat',
            locationGroup: 'Ubicació de grup',
            yes: 'Sí',
            no: 'No',
            rfidDriverTokens: 'Comparteix només les targetes RFID del conductor  ',
            vat_type: "Tipus d'IVA",
            version_2_1_1: '2.1.1',
            version_2_2: '2.2',
            version_2_2_1: '2.2.1',
            external_cpo: '##COMPANY_BRAND_NAME## CPO Internacional',
            cpo_type: 'Tipus de CPO',
            override_tariff: 'Anular tarifa',
            provides_session_total_cost_updates: 'Proporciona Actualitzacions Del Cost Total De La Sessió',
        },
        button: {
            search: 'Cercar',
            cancel: 'Cancel·lar',
            add: 'Afegir',
            save: 'Desa',
            edit: 'Editar',
            reset: 'Restablir',
            yes: 'Sí',
            no: 'No',
            enabled: 'Habilitar',
            disabled: 'Deshabilitar',
            action: 'Acció',
            back: 'Enrere',
            enable: 'Habilitar',
            disable: 'Deshabilitar',
            getCredentials: 'Obtén credencials',
            performHandshake: "Realitzar l'encaixada de mans",
            reHandshake: 'Re-encaixada de mans',
            generateHandshakeToken: "Genera un testimoni d'encaixada de mans",
            reGenerateHandshakeToken: "Regenera el testimoni d'encaixada",
            changeMutualOCPIVersion: 'Canviar la versió OCPI Mutual',
            handshakeDetails: "Detalls de l'encaixada de mans",
        },
        message: {
            enableConfirmMesage: 'Estàs segur que el vols habilitar?',
            disableConfirmMesage:
                "Desactivar aquest CPO aturarà tota la comunicació OCPI, ocultarà les ubicacions de càrrega associades a les aplicacions, marcarà les estacions de càrrega enllaçades com a 'Eliminades' i eliminarà les ubicacions dels grups d'accés. Esteu segur que voleu continuar?",
        },
        insert: {
            header: "Gestiona l'Operador del Punt de Càrrega",
            placeholder: {
                name: 'Nom',
                party_id: 'Identificador de la part',
                country_code: 'Codi del país',
                ocpi: 'EMSP',
                version_url: 'URL de la versió del CPO',
                token_a: 'Fitxa A',
                token_b: 'Fitxa B',
                token_c: 'Fitxa C',
                colour_code: 'Codi de color',
                back_office_url: 'URL del Back Office',
                vat_type: "Tipus d'IVA",
                region: 'Selecciona la regió',
                vat: "Selecciona l'IVA",
                cpo_type: 'Tipus de CPO',
            },
            label: {
                name: 'Nom',
                party_id: 'Identificador de la part',
                country_code: 'Codi del país',
                ocpi: 'EMSP',
                version_url: 'URL de la versió',
                token_a: 'Fitxa A',
                token_b: 'Fitxa B',
                token_c: 'Fitxa C',
                locationGroup: 'Ubicació de grup',
                rfidDriverTokens: 'Comparteix només les targetes RFID del conductor  ',
                colour_code: 'Codi de color',
                back_office_url: 'URL del Back Office',
                vat_type: "Tipus d'IVA",
                disableLocationPatchPutRemovals: 'Desactivar eliminacions de PATCH/PUT de la ubicació',
                enableAutoMaxPowerCalculation: 'Activar el càlcul automàtic de la potència màxima',
                mutual_ocpi_version: 'Versió OCPI mútua',
                externalCPO: 'Regió associada',
                is_external: '##COMPANY_BRAND_NAME## CPO Internacional',
                defaultVat: 'IVA per defecte (Sobreescriure)',
                gmbAccountID: 'Identificador del compte GMB',
                cpo_type: 'Tipus de CPO',
            },
            errors: {
                common: 'Alguna cosa ha anat malament, intenta-ho de nou.',
                name: {
                    valid: 'Introdueix un nom de CPO vàlid',
                },
                party_id: {
                    valid: 'Introdueix una ID de part vàlida',
                },
                country_code: {
                    valid: 'Introdueix un codi de país vàlid',
                },
                version_url: {
                    url: 'La URL de la versió ha de ser una URL vàlida',
                },
                colour_code: {
                    valid: 'Introdueix un codi de color vàlid',
                },
                back_office_url: {
                    url: 'La URL del Back Office ha de ser una URL vàlida',
                },
            },
        },
        versionEndpoints: {
            header: 'Punts finals de la versió',
            label: {
                version: 'Versió',
                identifier: 'Identificador',
                role: 'Rol',
                url: 'URL',
                last_executed: 'Última sincronització executada el',
            },
        },
        modal: {
            message:
                "Estàs marcant aquest CPO ##COMPANY_BRAND_NAME## com a CPO Internacional, has d'afegir manualment les ubicacions d'aquest CPO al grup d'accés públic",
            okButton: "D'acord",
        },
        performHandshakeModal: {
            handshakeHeader: 'Realitzar apretat de mans',
            reHandshakeHeader: "Tornar a fer l'apretat de mans",
            label: {
                mutual_ocpi_version: 'Versió OCPI mútua',
                version_url: 'URL de la versió',
                handshake_token: "Token d'apretat de mans",
            },
            placeholder: {
                mutual_ocpi_version: 'Versió OCPI mútua',
                version_url: 'URL de la versió',
                handshake_token: "Token d'apretat de mans",
            },
            button: {
                cancel: 'Cancel·lar',
                generateHandshakeToken: "Generar token d'apretat de mans",
                confirm: 'Confirmar',
                connect: "Connecta't",
                reconnect: 'Torna a connectar',
            },
            confirmationModal: {
                header: 'Realitzar apretat de mans',
                rehandshakeMessage:
                    "Les credencials CPO canviaran després de tornar a fer l'apretat de mans. Estàs segur que vols continuar amb la nova apretat de mans?",
                tokenGeneratedMessage:
                    "El token d'apretat de mans per al CPO ja s'ha generat. Si es dóna el token al CPO i intenta realitzar una apretat de mans amb l'EMSP, podria fallar. Estàs segur que vols continuar amb la nova apretat de mans?",
            },
            cpoAuthTokenMessage: "El valor predeterminat que es mostra aquí és el testimoni d'autenticació CPO",
        },
        generateHandshakeTokenModal: {
            header: "Generar token d'apretat de mans",
            reGenerateTokenHeader: "Tornar a generar token d'apretat de mans",
            label: {
                handshakeToken: "Token d'apretat de mans",
                emsp_auth_token: "Token d'autorització EMSP",
                emspVersionURL: 'URL de la versió EMSP',
            },
            Placeholder: {
                handshakeToken: "Token d'apretat de mans",
                emsp_auth_token: "Token d'autorització EMSP",
            },
            button: {
                save: 'Desar',
                copyToClipboard: 'Copiar al porta-retalls',
                generateToken: 'Generar',
                reGenerateToken: 'Tornar a generar',
                confirm: 'Confirmar',
                cancel: 'Cancel·lar',
            },
            copyToClipboard: {
                success: 'Token copiat al porta-retalls',
                failed: 'Error en copiar el token',
            },
            confirmationModal: {
                confirmationMessage:
                    "Si es dóna l'antic token d'apretat de mans al CPO, podria fallar si el CPO intenta utilitzar-lo per a l'apretat de mans. Estàs segur que vols desar el nou token d'apretat de mans?",
                header: 'Desar token',
            },
            emspAuthTokenMessage: "El valor predeterminat que es mostra aquí és el testimoni d'autenticació EMSP",
        },
        changeMutualOCPIVersionModal: {
            header: 'Canviar versió mútua OCPI',
            label: {
                mutualOCPIVersion: 'Versió mútua OCPI',
            },
            button: {
                save: 'Desar',
                cancel: 'Cancel·lar',
                confirm: 'Confirmar',
            },
            confirmationModal: {
                confirmationMessage: 'Estàs segur que vols actualitzar la versió mútua OCPI?',
            },
        },
        handshakeDetailsModal: {
            header: "Detalls de l'apretat de mans",
            label: {
                version_url: 'URL de la versió',
                handshakeToken: "Token d'apretat de mans",
                emspAuthToken: "Token d'autorització EMSP",
                cpoAuthToken: "Token d'autorització CPO",
            },
        },
    },
    CPOInternalTransfers: {
        title: 'Transferències Internes: ##COMPANY_BRAND_NAME## - Plataforma de serveis eMobility',
        header: 'Transferències Internes',
        transferDetailTitle: 'Detalls de la Transferència: ##COMPANY_BRAND_NAME## - Plataforma de serveis eMobility',
        transferDetailHeader: 'Detalls de la Transferència',
        label: {
            transfer_id: 'Identificador de transferència',
            gross_value: 'Valor brut',
            created_date: 'Data de creació',
            action: 'Acció',
            transferNumber: 'Número de transferència',
            transferDate: 'Data de transferència',
            transaction: 'Identificador de transacció',
            transactionStartDate: "Data d'inici de la transacció",
            transactionEndDate: 'Data de finalització de la transacció',
            publicCardId: 'ID de la targeta RFID pública',
            driverAccountId: 'Identificador del compte del conductor',
            driverName: 'Número de conductor/vehicle',
            stationId: "Identificador de l'estació",
            stationName: "Nom de l'estació",
            stationAddress: "Adreça de l'estació",
            kwh: 'kWh',
            price_per_kwh: 'Preu/kWh',
            disable: 'DESHABILITAT',
        },
        placeholder: {
            start_date: "Data d'inici",
            end_date: 'Data de finalització',
            status: 'Estat',
            cpo: 'Selecciona CPO',
        },
        button: {
            search: 'Cercar',
            reset: 'Restablir',
            action: 'Acció',
        },
        errors: {
            cpo: {
                required: 'Selecciona un CPO',
            },
        },
    },
    PSPSetting: {
        title: 'Proveïdors de Serveis de Pagament: ##COMPANY_BRAND_NAME## - Plataforma de serveis eMobility',
        header: 'Proveïdor de serveis de pagament',
        placeholder: {
            name: 'Nom',
            status: "Selecciona l'estat",
            type: 'Selecciona el tipus',
        },
        label: {
            name: 'Nom',
            code: 'Codi',
            type: 'Tipus',
            description: 'Descripció',
            store_name: 'Botiga',
            department_name: 'Departament',
            created_date: 'Data de creació',
            status: 'Estat',
            action: 'Acció',
            enabled: 'Habilitat',
            disabled: 'Deshabilitat',
            details: 'Detalls',
            key: 'Clau',
            value: 'Valor',
        },
        button: {
            search: 'Cercar',
            cancel: 'Cancel·lar ',
            add: 'Afegir',
            save: 'Desa',
            edit: 'Editar',
            reset: 'Restablir',
            yes: 'Sí',
            no: 'No',
            enabled: 'Habilitar',
            disabled: 'Deshabilitar',
            action: 'Acció',
            back: 'Enrere',
            enable: 'Habilitar',
            disable: 'Deshabilitar',
            getCredentials: 'Obtén credencials',
            delete: 'Eliminar',
        },
        message: {
            enableConfirmMesage: 'Estàs segur que el vols habilitar?',
            disableConfirmMesage: 'Estàs segur que el vols deshabilitar?',
        },
        insert: {
            header: 'Gestiona el Proveïdor de Servei de Pagament',
            placeholder: {
                name: 'Nom',
                type: 'Tipus',
                description: 'Descripció',
                store_name: 'Nom de la botiga',
                store_id: 'Identificador de la botiga',
                merchant_name: 'Nom del comerciant',
                merchant_id: 'Identificador del comerciant',
                department_name: 'Nom del departament',
                department_id: 'Identificador del departament',
                signature_key: 'Clau de signatura',
                secret_key: 'Clau secreta',
                user_name: "Nom d'usuari",
                password: 'Contrasenya',
                data: 'Dades',
                category: 'Categoria',
                url: 'URL',
                acquirerId: "Identificador de l'adquirent",
                firstName: 'Nom',
                lastName: 'Cognom',
                houseName: 'Nom de la casa',
                postcode: 'Codi postal',
                donationProviderType: 'Tipus de proveïdor de donacions',
                isGiftAid: 'És ajuda per a donatius',
                donationStoreId: 'Identificador de la botiga de donacions',
                donationMerchantNumber: 'Número del comerciant de donacions',
                clientID: 'Identificador del client',
                clientSecret: 'Secret del client',
                terminalID: 'Identificador del terminal',
                enableCardRefunds: 'Activar reemborsaments de targeta',
                enableCardVerification: 'Activar verificació de targeta',
                enableCharity: 'Activar donació',
            },
            label: {
                name: 'Nom',
                type: 'Tipus',
                firstName: 'Nom',
                lastName: 'Cognom',
                houseName: 'Nom de la casa',
                postcode: 'Codi postal',
                donationProviderType: 'Tipus de proveïdor de donacions',
                isGiftAid: 'És ajuda per a donatius',
                donationStoreId: 'Identificador de la botiga de donacions',
                donationMerchantNumber: 'Número del comerciant de donacions',
                code: 'Codi',
                description: 'Descripció',
                store_name: 'Nom de la botiga',
                store_id: 'Identificador de la botiga',
                merchant_name: 'Nom del comerciant',
                merchant_id: 'Identificador del comerciant',
                department_name: 'Nom del departament',
                department_id: 'Identificador del departament',
                signature_key: 'Clau de signatura',
                secret_key: 'Clau secreta',
                user_name: "Nom d'usuari",
                password: 'Contrasenya',
                data: 'Dades',
                action_urls: 'Acció URLs',
                category: 'Categoria',
                url: 'URL',
                acquirerId: "Identificador de l'adquirent",
                clientID: 'Identificador del client',
                clientSecret: 'Secret del client',
                terminalID: 'Identificador del terminal',
                enableCardRefunds: 'Activar reemborsaments de targeta',
                enableCardVerification: 'Activar verificació de targeta',
                enableCharity: 'Activar donació',
                mobileMerchantId: 'Identificador de comerciant mòbil',
                mobileMerchantPassword: 'Contrasenya de comerciant mòbil',
                enableIncrementalAuthorizations: 'Habilita les Autoritzacions Incrementals',
                excludedCardsForIncrementalAuthorizations: 'Targetes excloses per a autoritzacions incrementals',
            },
            errors: {
                common: 'Alguna cosa ha anat malament, intenta-ho de nou.',
                name: {
                    valid: 'Introdueix un nom vàlid',
                },
                code: {
                    valid: 'Introdueix un codi vàlid',
                },
                url: {
                    valid: 'La URL ha de ser una URL vàlida',
                },
                DatatransSupportCards: {
                    valid: 'Introduïu un valor vàlid per a les targetes DatatransSupportCards',
                },
            },
        },
    },
    RFIDCards: {
        title: 'Targetes RFID: ##COMPANY_BRAND_NAME## - Plataforma de servei eMobility',
        header: 'Targetes RFID',
        placeholder: {
            name: 'Nom del conductor/Correu electrònic/Organització',
            manufacturer: 'Fabricant',
            part_id: 'Identificador de la part',
            public_card_id: 'Identificador de la targeta pública',
            status: "Selecciona l'estat",
            mifare_uid: 'UID Mifare',
        },
        label: {
            name: 'Assignada a',
            email_vehicle: 'Compte associat',
            manufacturer: 'Fabricant',
            part_id: 'Identificador de la part',
            public_card_id: 'Identificador de la targeta pública',
            private_card_id: 'Identificador de la targeta privada',
            created_date: 'Data de creació',
            status: 'Estat',
            action: 'Acció',
            enabled: 'Habilitat ',
            disabled: 'Deshabilitat',
            delete: 'Eliminar',
            deAllocate: 'Eliminar associació',
            view: 'Veure detalls',
            allocateCardToOrganisation: "Assignar targetes a granel a l'organització",
            mifare_uid: 'UID MIFARE',
            reinstate: 'Reactivar targeta',
            card_type: 'Tipus de targeta',
            removeBulkAssociation: 'Eliminar associacions de targetes RFID a granel',
        },
        button: {
            search: 'Cercar',
            cancel: 'Cancel·lar',
            add: 'Afegir',
            addBulk: 'Afegeix targetes a granel a la fabricació',
            assing: 'Assignar targetes RFID',
            allocateRFIDCard: 'Assignar targeta RFID',
            import: 'Importar fitxer de fabricació',
            export: 'Exportar fitxer de fabricació',
            save: 'Desa',
            edit: 'Editar',
            reset: 'Restablir',
            yes: 'Sí',
            no: 'No',
            enabled: 'Habilitar',
            disabled: 'Deshabilitar',
            action: 'Acció',
            back: 'Enrere',
            enable: 'Habilitar',
            disable: 'Deshabilitar',
            getCredentials: 'Obtén credencials',
            delete: 'Eliminar',
            deAllocate: 'Eliminar associació',
            view: 'Veure detalls',
            reinstate: 'Reactivar targeta',
            forceCPOUpdate: 'Forçar actualització del CPO',
        },
        errors: {
            export: {
                notSeletedCards: 'Selecciona les targetes Esperant exportació',
            },
        },
        message: {
            enableConfirmMesage: 'Estàs segur que el vols habilitar?',
            disableConfirmMesage: 'Estàs segur que el vols deshabilitar?',
            deleteConfirmMesage: 'Estàs segur que el vols eliminar?',
            deAllocateConfirmMesage: "Segur que vols eliminar l'associació de la targeta RFID a un compte?",
            reinstateConfirmMessage: 'Segur que vols reactivar la targeta RFID?',
            forceCPOUpdateConfirmMessage: "Segur que vols forçar l'actualització de la fitxa al sistema del CPO?",
        },
        insert: {
            header: 'Gestiona les targetes RFID',
            placeholder: {
                manufacturer: 'Nom del fabricant',
                part_id: 'Identificador de la part',
                public_card_id: 'Identificador de la targeta pública',
                private_card_id: 'Identificador de la targeta privada',
                mifare_uid: 'UID Mifare',
                card_type: 'Tipus de targeta',
            },
            label: {
                manufacturer: 'Fabricant',
                part_id: 'Identificador de la part',
                public_card_id: 'Identificador de la targeta pública',
                private_card_id: 'Identificador de la targeta privada',
                mifare_uid: 'UID Mifare',
                card_type: 'Tipus de targeta',
            },
            errors: {
                common: 'Alguna cosa ha anat malament, intenta-ho de nou.',
                name: {
                    valid: 'Introdueix un nom vàlid',
                },
                code: {
                    valid: 'Introdueix un codi vàlid',
                },
                url: {
                    valid: 'La URL ha de ser una URL vàlida',
                },
            },
        },
        bulkCards: {
            header: 'Afegeix targetes en massa',
            placeholder: {
                manufacturer: 'Nom del fabricant',
                part_id: 'Identificador de la part',
                no_of_cards: '100 targetes',
                cardType: 'Selecciona el tipus de targeta',
            },
            label: {
                manufacturer: 'Nom del fabricant',
                part_id: 'Identificador de la part',
                no_of_cards: 'Nombre de targetes',
                cardType: 'Tipus de targeta',
            },
            button: {
                yes: 'Crea targetes',
                no: 'Cancel·lar',
            },
            errors: {
                no_of_cards: {
                    min: 'El nombre de targetes no pot ser menor de 1',
                },
            },
        },
        assignCards: {
            header: 'Assignar targetes RFID',
            header2: 'Has seleccionat X targetes.',
            selectedCard: 'Has seleccionat 1 targeta.',
            placeholder: {
                manufacturer: 'Nom del fabricant',
                part_id: 'Identificador de la part',
                no_of_cards: '100 targetes',
            },
            label: {
                driver: 'Conductor',
                organisation: 'Organització',
                no_of_cards: 'Nombre de targetes',
            },
            button: {
                yes: 'Assignar',
                no: 'Cancel·lar ',
            },
            form: {
                type: {
                    driver: 'Conductor',
                    organisation: 'Organització',
                },
                driver: 'Conductor',
                organisation: 'Organització',
                placeholder: {
                    driver: 'Selecciona el conductor',
                    organisation: "Selecciona l'organització",
                },
            },
            errors: {
                notSeletedCards: 'Si us plau, selecciona les targetes disponibles',
            },
        },
        disableCards: {
            header: 'Deshabilitar',
            header2: 'Estàs segur que el vols deshabilitar?',
            placeholder: {
                comment: 'Introdueix un comentari',
            },
            label: {
                comment: 'Comentari',
            },
            button: {
                yes: 'Sí',
                no: 'No',
            },
        },
        allocateCards: {
            header: 'Assignar targetes RFID',
            placeholder: {
                file: 'Selecciona el fitxer CSV',
                selectOrganisation: "Selecciona l'organització",
            },
            label: {
                file: 'Fitxer CSV',
                organisation: 'Organització',
                mifareUID: 'UID Mifare',
                publicCardID: 'Identificador de la targeta pública',
                clickHere: 'Feu clic aquí',
                downloadTemplate: 'per descarregar la plantilla',
            },
            button: {
                allocate: 'Assignar',
                cancel: 'Cancel·lar ',
            },
            errors: {
                file: {
                    fileType: "Es poden carregar arxius amb extensió '.csv'.",
                },
            },
        },
        removeAssociation: {
            header: 'Eliminar associacions de targetes RFID a granel',
            placeholder: {
                file: 'Selecciona el fitxer CSV',
            },
            label: {
                file: 'Fitxer CSV',
                clickHere: 'Feu clic aquí',
                downloadTemplate: 'per descarregar la plantilla',
            },
            button: {
                save: 'Desa',
                cancel: 'Cancel·lar ',
            },
            errors: {
                file: {
                    fileType: "Es poden carregar arxius amb extensió '.csv'.",
                },
                maxRFIDRecordsReached:
                    "El fitxer CSV que has carregat ha arribat al nombre màxim de 10.000 registres d'identificador de targeta pública de targeta RFID, redueix els registres d'identificador de targeta pública de targeta RFID al fitxer CSV.",
            },
        },
        importCards: {
            header: 'Importar targetes RFID',
            placeholder: {
                file: 'Selecciona el fitxer CSV',
            },
            label: {
                file: 'Fitxer CSV',
            },
            button: {
                yes: 'Importar',
                no: 'Cancel·lar ',
            },
            errors: {
                file: {
                    fileType: "Es poden carregar arxius amb extensió '.csv'.",
                },
            },
        },
        importCardsDetails: {
            header: 'Detalls de la importació de targetes RFID',
            label: {
                unSuccessfullImport: 'Les següents targetes no es poden importar',
                successfullImport: 'Les següents targetes s’han importat correctament',
                failerReason: 'Motiu de la fallada',
                publicCardId: 'ID de targeta pública',
            },
            message: {
                defualtErrorMessage: 'Hi ha un problema en importar les targetes següents.',
            },
        },
        rfidDetails: {
            label: {
                event_date: "Data de l'esdeveniment",
                chargeLocation: 'Ubicació de la càrrega',
                charge_station_name: "Nom de l'estació",
                response_status: 'Estat de resposta',
            },
        },
    },
    referralPromotion: {
        title: 'Promoció de referència: ##COMPANY_BRAND_NAME## - Plataforma de servei eMobility',
        header: 'Promocions de referència',
        manageReferralPromotion: 'Gestiona la promoció de referència',
        label: {
            name: 'Nom',
            code: 'Codi',
            minCharge: 'Mín. Càrrega',
            maxLimit: 'Màx. Límit',
            maxRefreeLimit: 'Màx. Límit del revisor',
            createdDate: 'Data de creació',
            status: 'Estat',
            action: 'Acció',
            disabled: 'Deshabilitat',
            enabled: 'Habilitat ',
            delete: 'Eliminar',
            enable: 'Habilitar',
            disable: 'Deshabilitar',
            promotionCode: 'Codi de promoció',
            description: 'Descripció',
            maxReferralLimit: 'Límit màxim del referència',
            minChargeValue: 'Valor mínim de la càrrega',
            refereeBonus: 'Bonificació del revisor',
            referrerBonus: 'Bonificació del referent',
        },
        button: {
            search: 'Cercar',
            back: 'Enrere',
            add: 'Afegir',
            reset: 'Restablir',
            edit: 'Editar',
            delete: 'Eliminar',
            enable: 'Habilitar',
            disable: 'Deshabilitar',
            save: 'Desa',
            cancel: 'Cancel·lar',
            action: 'Acció',
        },
        message: {
            deleteConfirmMesage: 'Estàs segur que el vols eliminar?',
            enableConfirmMesage: 'Estàs segur que el vols habilitar?',
            disableConfirmMesage: 'Estàs segur que el vols deshabilitar?',
        },
        placeholder: {
            name: 'Nom',
            code: 'Codi',
            selectPromotion: 'Selecciona la promoció',
            selectStatus: "Selecciona l'estat",
            promotionCode: 'Codi de promoció',
            description: 'Descripció',
            maxReferralLimit: 'Límit màxim de referència',
            minChargeValue: 'Valor mínim de la càrrega',
            refereeBonus: 'Bonificació del revisor',
            referrerBonus: 'Bonificació del referent',
        },
        errors: {
            name: {
                valid: 'Introdueix un nom de promoció vàlid',
            },
            promotionCode: {
                valid: 'Introdueix un codi de promoció vàlid',
            },
            maxReferralLimit: {
                moreThan: 'El límit màxim de referència ha de ser superior a zero',
            },
            referrerBonus: {
                max: 'El valor del Bo per a Referidor no pot ser superior a ##MAX_REFERRAL_BONUS##',
            },
            refereeBonus: {
                max: 'El valor del Bo per a Referit no pot ser superior a ##MAX_REFERRAL_BONUS##',
            },
        },
    },
    termsConditions: {
        title: 'Termes i condicions: ##COMPANY_BRAND_NAME## - Plataforma de servei eMobility',
        header: 'Termes i condicions',
        manageTermsConditions: 'Gestionar termes i condicions',
        label: {
            enabled: 'Habilitat ',
            disabled: 'Deshabilitat',
            name: 'Nom',
            description: 'Descripció',
            apply_to: 'Aplicar a',
            mandatory_for_user: "Obligatori per a l'usuari",
            status: 'Estat',
            delete: 'Eliminar',
            content: 'Contingut de la política',
            yes: 'Sí',
            no: 'No',
            draft: 'Esborrany',
            published: 'Publicat',
        },
        placeholder: {
            name: 'Nom',
            description: 'Descripció',
            select: {
                apply_to: 'Aplicar a',
                status: "Selecciona l'estat",
            },
        },
        columns: {
            name: 'Nom',
            description: 'Descripció',
            applyto: 'Aplicar a',
            mandatory_for_user: 'Obligatori',
            status: 'Estat',
            action: 'Acció',
            modified_date: 'Modificat el',
        },
        button: {
            search: 'Cercar',
            reset: 'Restablir',
            action: 'Acció',
            edit: 'Editar',
            add: 'Afegir',
            back: 'Enrere',
            save: 'Desa',
            cancel: 'Cancel·lar',
            delete: 'Eliminar',
            yes: 'Sí',
            no: 'No',
        },
        errors: {
            name: {
                valid: 'Introdueix un nom vàlid',
            },
            invalidFormat: "Puja un format d'imatge vàlid",
            common: 'Alguna cosa ha anat malament, intenta-ho de nou.',
        },
        message: {
            deleteConfirmMesage: 'Estàs segur que el vols eliminar?',
        },
    },
    rewardPromotion: {
        title: 'Promocions de recompensa: ##COMPANY_BRAND_NAME## - Plataforma de servei eMobility',
        header: 'Promocions de recompensa IV',
        manageRewardPromotion: 'Gestionar promoció de recompensa IV',
        label: {
            name: 'Nom',
            code: 'Codi',
            valuesPerkwh: 'Valors per kWh',
            monetoryValue: 'Valor monetari',
            redemptionBlock: 'Bloqueig de redempció',
            createdDate: 'Data de creació',
            status: 'Estat',
            enabled: 'Habilitat',
            disabled: 'Deshabilitat',
            action: 'Acció',
            delete: 'Eliminar',
            enable: 'Habilitar',
            disable: 'Deshabilitar',
            promotionCode: 'Codi de promoció',
            description: 'Descripció',
            expired: 'Caducat',
            locationApplicable: 'Ubicació de càrrega aplicable',
            voltsPerkwh: 'Volts per kWh',
            confirmation: 'Confirmació',
        },
        button: {
            search: 'Cercar',
            cancel: 'Cancel·lar ',
            save: 'Desa',
            add: 'Afegir',
            edit: 'Editar',
            reset: 'Restablir',
            delete: 'Eliminar',
            enable: 'Habilitar',
            disable: 'Deshabilitar',
            action: 'Acció',
            back: 'Enrere',
        },
        message: {
            deleteConfirmMesage: 'Estàs segur que el vols eliminar?',
            enableConfirmMesage: 'Estàs segur que el vols habilitar?',
            disableConfirmMesage: 'Estàs segur que el vols deshabilitar?',
            uncheckConfirmMesage:
                'En desmarcar aquesta casella, totes les ubicacions de càrrega associades a aquesta promoció seran eliminades. Estàs segur que vols eliminar-la?',
        },
        placeholder: {
            name: 'Nom',
            code: 'Codi',
            selectPromotion: 'Selecciona la promoció',
            selectStatus: "Selecciona l'estat",
            locationApplicable: 'Ubicació de càrrega aplicable',
            voltsPerkwh: 'Volts per kWh',
        },
        errors: {
            name: {
                valid: 'Introdueix un nom de promoció vàlid',
            },
            promotionCode: {
                valid: 'Introdueix un codi de promoció vàlid',
            },
            monetoryValue: {
                moreThan: 'El valor monetari ha de ser superior a zero',
                lessThan: 'El valor monetari ha de ser inferior o igual a 99999,99',
                typeError: 'Introdueix un valor monetari vàlid',
            },
            redemptionPointBlock: {
                moreThan: 'El bloqueig de redempció ha de ser superior a zero',
            },
            valuePerKwh: {
                moreThan: 'El valor ha de ser superior a zero',
            },
        },
    },
    amenitys: {
        title: 'Equipaments: ##COMPANY_BRAND_NAME## - Plataforma de servei eMobility',
        header: 'Equipaments',
        manageamenitys: 'Gestionar Serveis',
        chargeStationsList: 'Estacions de càrrega',
        chargeLocation: 'Ubicacions de càrrega',
        amenityTranslationNote:
            "Introdueix els detalls de l'equipament per als usuaris/controladors d'administració en la llengua respectiva de la regió. Quan no s'hagin introduït detalls per a un idioma específic, el sistema mostrarà els detalls per defecte.",
        label: {
            enabled: 'Habilitat ',
            disabled: 'Deshabilitat',
            name: 'Nom',
            imageUpload: 'Icona (34 X 34)',
            language: 'Idioma',
            image: 'Icona',
            description: 'Descripció',
            default_search: 'Cerca per defecte',
            status: 'Estat',
            delete: 'Eliminar',
            csvFile: 'Fitxer CSV',
            importAmenityHeader: 'Importar Serveis',
            chargeLocation: {
                name: 'Nom',
                type: 'Tipus',
                address: 'Adreça',
                city: 'Ciutat',
                postal_code: 'Codi postal',
                modifiedDate: 'Data de modificació',
                action: 'Acció',
            },
            charge_station_name: 'Charge_Station_Name',
            charge_point: 'Charge_Point',
            charge_location_name: 'Charge_Location_Name',
            latitude: 'Latitud',
            longitude: 'Longitud',
            location_address: 'Location_Address',
            amenities: 'Equipaments',
            amenity_type: 'Tipus de servei',
        },
        placeholder: {
            name: 'Nom',
            description: 'Descripció',
            file: 'Selecciona el fitxer CSV',
            select: {
                status: "Selecciona l'estat",
                amenity_type: 'Selecciona el tipus',
            },
        },
        columns: {
            name: 'Nom',
            description: 'Descripció',
            status: 'Estat',
            action: 'Acció',
            amenity_type: 'Tipus',
        },
        button: {
            search: 'Cercar',
            reset: 'Restablir',
            action: 'Acció',
            edit: 'Editar',
            add: 'Afegir',
            back: 'Enrere',
            save: 'Desa',
            cancel: 'Cancel·lar',
            delete: 'Eliminar',
            yes: 'Sí',
            no: 'No',
            disable: 'Deshabilitar',
            enable: 'Habilitar',
            import: 'Importar',
        },
        errors: {
            common: 'Alguna cosa ha anat malament, intenta-ho de nou.',
            name: {
                valid: 'Introdueix un nom vàlid.',
            },
            image: {
                fileType: "Arxiu amb extensió '.jpg', '.png', '.svg', '.jpeg' es pot pujar.",
                dimensions: 'La icona ha de tenir les dimensions 34 x 34',
                required: 'La icona és un camp obligatori',
            },
        },
        message: {
            deleteConfirmMesage: 'Estàs segur que el vols eliminar?',
            enableConfirmMesage: 'Estàs segur que el vols habilitar?',
            disableConfirmMesage: 'Estàs segur que el vols deshabilitar?',
        },
    },
    vehicle: {
        title: 'Vehicle: ##COMPANY_BRAND_NAME## - Plataforma de servei eMobility',
        header: 'Vehicles',
        columns: {
            name: 'Nom',
            registerNo: 'Matrícula',
            make: 'Marca',
            model: 'Model',
            chargeType: 'Tipus de càrrega',
            batteryCapacity: 'Capacitat de la bateria',
            consumption: 'Consum',
        },
        placeholder: {
            nameEmail: 'Nom/Correu electrònic',
            makeModelRegistrationNo: 'Marca/Model/Matrícula',
        },
        button: {
            search: 'Cercar',
            reset: 'Restablir',
        },
    },
    incompleteSessions: {
        title: 'Sessions incompletes: ##COMPANY_BRAND_NAME## - Plataforma de servei eMobility',
        header: 'Sessions incompletes',
        placeholder: {
            nameOrEmail: 'Nom/Correu electrònic',
            locationOrStation: 'Ubicació/Estació',
            startDate: "Data d'inici",
            endDate: 'Data de finalització',
            status: "Selecciona l'estat",
            comment: 'Introdueix els teus comentaris',
        },
        label: {
            invalid: 'No vàlid',
            generateCDR: 'Genera CDR',
            totalEnergy: 'Energia total',
            totalCost: 'Cost total',
            comment: 'Introdueix els teus comentaris',
            cancelCDR: 'Cancel·lar CDR',
        },
        columns: {
            name: 'Nom',
            location: 'Ubicació',
            sessionId: 'Identificador de la sessió',
            startDate: "Data d'inici",
            modifiedDate: 'Data de modificació',
            time: 'Temps',
            energy: 'Energia </br> (kWh)',
            cost: 'Cost',
            status: 'Estat',
            action: 'Acció',
        },
        button: {
            action: 'Acció',
            generateCDR: 'Genera CDR',
            search: 'Cercar',
            reset: 'Restablir',
            save: 'Desa',
            cancel: 'Cancel·lar',
            yes: 'Sí',
            no: 'No',
            cancelCDR: 'Cancel·lar CDR',
        },
        error: {
            max: 'Màxim 250 caràcters permesos',
        },
        message: {
            cancelCDRMessage: 'Estàs segur que vols cancel·lar la sessió?',
            cancelBulkCDRMessage: 'Estàs segur que vols cancel·lar la sessió?',
            selectCDR: 'Seleccioneu les sessions incompletes',
        },
    },
    ocpiSessions: {
        title: 'Sessions OCPI: ##COMPANY_BRAND_NAME## - Plataforma de servei eMobility',
        header: 'Sessions',
        placeholder: {
            nameOrEmail: 'Nom/Correu electrònic',
            locationOrStation: 'Ubicació/Estació',
            startDate: "Data d'inici",
            endDate: 'Data de finalització',
            status: "Selecciona l'estat",
            comment: 'Introdueix els teus comentaris',
        },
        columns: {
            name: 'Nom',
            location: 'Ubicació',
            sessionId: 'Identificador de la sessió',
            startDate: "Data d'inici",
            endDate: 'Data de finalització',
            time: 'Temps',
            energy: 'Energia </br> (kWh)',
            cost: 'Cost',
            status: 'Estat',
            action: 'Acció',
            vehicleNumber: 'Número del vehicle',
        },
        button: {
            search: 'Cercar',
            reset: 'Restablir',
            complete: 'Completar',
        },
        label: {
            complete: 'Completar',
            completeSessions: 'Completar les sessions de càrrega',
        },
        message: {
            completeConfirmMessage: 'Vols completar la sessió de càrrega?',
            stopBulkSessionsMessage: 'Vols completar les sessions de càrrega seleccionades?',
            selectSession: 'Selecciona les sessions de càrrega',
        },
    },
    organisation: {
        title: "Gestiona l'organització: ##COMPANY_BRAND_NAME## - Plataforma de servei eMobility",
        header: 'Organització',
        manageOrganisation: "Gestiona l'organització",
        label: {
            name: 'Nom',
            description: 'Descripció',
            address: 'Adreça',
            city: 'Ciutat',
            county: 'Comtat',
            postal_code: 'Codi postal',
            contact_person: 'Persona de contacte',
            email: 'Correu electrònic',
            phone_number: 'Núm. telèfon',
            payment_mode: 'Mode de pagament',
            payment_schedule: 'Horari de pagament',
            user_group_ids: "Grups d'usuaris",
            enabled: 'Habilitat',
            disabled: 'Deshabilitat',
            amount: 'Límit de crèdit',
            po_number: 'Número de comanda',
            finance_account_number: 'Número de compte financer  ',
            account_contact_email: 'Correu electrònic de contacte del compte',
            remaining_credit: 'Crèdit restant (%)',
            remoteChargePassword: 'Inicia la contrasenya de càrrega remota',
            is_deleted: "S'ha eliminat",
            yes: 'Sí',
            deleted: 'Eliminat',
            dailySpendLimit: 'Límit diari de despesa',
            weeklySpendLimit: 'Límit setmanal de despesa',
            monthlySpendLimit: 'Límit de despesa del mes calendari',
            defaultSpendLimitGroup: 'Grup de límit de despesa per defecte',
            updateSpendLimitAssociation: 'Associació de grup de límit de despesa',
            promotionUpdate: 'Actualització de la promoció',
            currentPromotion: 'Promoció actual',
            newPromotion: 'Nova promoció',
        },
        placeholder: {
            name: 'Nom',
            name_or_email_or_contact_person: 'Nom/Persona de contacte/Correu electrònic',
            description: 'Descripció',
            address: 'Adreça',
            city: 'Ciutat',
            county: 'Comtat',
            postal_code: 'Codi postal',
            contact_person: 'Persona de contacte',
            email: 'Correu electrònic',
            phone_number: 'Núm. telèfon',
            select: {
                status: "Selecciona l'estat",
                payment_mode: 'Selecciona el mode de pagament',
                payment_schedule: "Selecciona l'horari de pagament",
                user_group_ids: "Selecciona els grups d'usuaris",
            },
            amount: 'Límit de crèdit ',
            po_number: 'Número de comanda',
            finance_account_number: 'Número de compte financer',
            remaining_credit: 'Crèdit restant (%)',
            remoteChargePassword: 'Inicia la contrasenya de càrrega remota',
            enableSpendLimit: 'Activa el límit de despesa',
            defaultSpendLimitGroup: 'Selecciona el grup de límits de despesa per defecte',
            selectCurrentPromotion: 'Selecciona la promoció actual',
            selectNewPromotion: 'Selecciona una promoció nova',
        },
        columns: {
            name: 'Nom',
            contact_Person: 'Persona de contacte',
            email: 'Correu electrònic',
            payment_mode: 'Mode de pagament',
            payment_schedule: 'Horari de pagament',
            created_date: 'Creat el',
            status: 'Estat',
            action: 'Acció',
            remote_charge_password: 'Inicia la contrasenya de càrrega remota',
            promotion: 'Promoció',
        },
        button: {
            search: 'Cercar',
            reset: 'Restablir',
            action: 'Acció',
            edit: 'Editar',
            add: 'Afegir',
            back: 'Enrere',
            save: 'Desa',
            cancel: 'Cancel·lar',
            delete: 'Eliminar',
            yes: 'Sí',
            no: 'No',
            enable: 'Habilitar',
            disable: 'Deshabilitar',
            permission: 'Permís API',
            assignSpendLimitGroup: 'Assigna un grup de límits de despesa',
        },
        errors: {
            name: {
                valid: 'Introdueix un nom vàlid',
            },
            contact_person: {
                valid: 'Introdueix una persona de contacte vàlida',
            },
            email: {
                required: 'Introdueix una adreça de correu electrònic',
                email: 'Introdueix una adreça de correu electrònic vàlida',
            },
            phoneNo: {
                required: 'Introdueix número de telèfon',
                match: 'Introdueix número de telèfon vàlid',
            },
            amount: {
                moreThan: "L'import ha de ser superior a 0",
                maxcredit: 'Límit màxim assolit per al crèdit del compte',
            },
            po_number: {
                valid: 'Introdueix un número de comanda vàlid',
            },
            finance_account_number: {
                valid: 'Introdueix un número de compte financer vàlid',
            },
            account_contact_email: {
                required: 'Introdueix almenys una adreça de correu electrònic',
                maxLimit: "S'ha assolit el límit màxim per al correu electrònic de contacte del compte",
            },
            remaining_credit: {
                match: 'Introdueix un crèdit restant vàlid',
                maxCredit: 'El valor màxim del crèdit restant no ha de superar el 100',
                minCredit: 'El valor mínim del crèdit restant no ha de ser inferior a 0',
            },
            value: {
                moreThan: 'El valor ha de ser superior a 0',
                lessThan: 'El valor ha de ser igual o inferior a 5000',
                number: 'El valor ha de ser un número',
                lessThanWeekly: 'El valor ha de ser inferior o igual al límit de despesa setmanal',
                lessThanMonthly: 'El valor ha de ser inferior o igual al límit de despesa mensual',
            },
            spend_limit: {
                moreThan: 'El límit setmanal de despesa ha de ser superior al límit diari de despesa',
                lessThan: 'El límit diari de despesa ha de ser inferior al límit setmanal de despesa',
            },
            address: 'es requereix un mínim de 10 caràcters',
            addressValid: "Introdueix l'adreça vàlida",
            user_group: {
                required: "Selecciona almenys un grup d'usuaris",
            },
        },
        message: {
            deleteConfirmMesage: 'Estàs segur que el vols eliminar?',
            enableConfirmMesage: 'Estàs segur que el vols habilitar?',
            disableConfirmMesage: 'Estàs segur que el vols deshabilitar?',
            assignAllDriversToDefaultGroup:
                "Vols assignar tots els conductors d'aquesta organització al grup de límit de despesa per defecte?",
            updatePromotionConfirmMessage:
                'Estàs segur que vols actualitzar la promoció per a les organitzacions seleccionades?',
            selectOneRecord: "Selecciona com a mínim una organització per a l'actualització de la promoció",
            promotionAssignMessage: "La nova promoció s'assignarà a les següents organitzacions:",
        },
        permission: {
            header: 'Permís API',
            label: {
                description: 'Descripció',
                action: 'APIs',
            },
        },
    },
    transactionLogs: {
        title: 'Registres de transaccions: ##COMPANY_BRAND_NAME## - Plataforma de servei eMobility',
        header: 'Registres de transaccions',
        placeholder: {
            page: 'Selecciona la pàgina',
            email: 'Adreça de correu electrònic',
            startDate: "Data d'inici",
            endDate: 'Data de finalització',
            fieldName: 'Nom del camp',
            content: 'Contingut',
        },
        button: {
            search: 'Cercar',
            reset: 'Restablir',
        },
        label: {
            tableName: 'Nom de la taula',
            fieldName: 'Nom del camp',
            oldValue: 'Valor antic',
            newValue: 'Nou valor',
            user: 'Usuari',
            logDate: 'Data del registre',
            action: 'Acció',
            goToPage: 'Anar a la pàgina',
        },
    },
    organisationAccountBalance: {
        title: "Saldo del compte de l'organització: ##COMPANY_BRAND_NAME## - Plataforma de serveis eMobility",
        header: "Saldo del compte de l'organització",
        manageUser: "Gestiona el saldo del compte de l'organització",
        columns: {
            currentBalance: 'Saldo actual',
            closingBalance: 'Saldo a tancar',
            availableCredit: 'Crèdit disponible',
            unbilledAmount: 'Import no facturat',
            name: 'Nom',
            contact_Person: 'Persona de contacte',
            email: 'Correu electrònic',
            payment_mode: 'Mode de pagament',
            payment_schedule: 'Horari de pagament',
            balance: 'Saldo',
            status: 'Estat',
            action: 'Acció',
            refund: 'Esmenar saldo del compte',
        },
        placeholder: {
            name: 'Nom/Persona de contacte/Correu electrònic',
            description: 'Comentari',
            amount: " Introduïu l'import a Crèdit/Dèbit",
            select: {
                status: "Selecciona l'estat",
                payment_mode: 'Mode de pagament',
                payment_schedule: 'Horari de pagament',
            },
            invoice: 'Selecciona la factura',
        },
        label: {
            description: 'Comentari',
            amount: " Introduïu l'import a Crèdit/Dèbit",
            payment_settlement: 'Modificació de saldo - Sol·licitud',
            enabled: 'Habilitat ',
            disabled: 'Deshabilitat',
            invoice: 'Factura',
        },
        button: {
            search: 'Cercar',
            cancel: 'Cancel·lar',
            save: 'Desa',
            add: 'Afegir',
            edit: 'Editar',
            reset: 'Restablir',
            action: 'Acció',
            send_for_approval: 'Enviar per a aprovació',
            accept: 'Acceptar',
        },
        errors: {
            amount: {
                moreThan: "L'import ha de ser més gran/més petit que 0",
                maxcredit: 'Límit màxim assolit per al crèdit del compte',
                maxdebit: 'Límit màxim assolit per al dèbit del compte',
            },
        },
    },
    driverAward: {
        rewardTitle:
            'Saldo de recompenses - ##COMPANY_BRAND_NAME##: Càrrega ràpida de vehicles elèctrics al Regne Unit',
        approvalRequest:
            'Aprobacions de saldo de recompensa - ##COMPANY_BRAND_NAME##: Càrrega ràpida de vehicles elèctrics al Regne Unit',
        rewards: 'Saldo de recompensa',
        approvalRequests: 'Aprobacions de saldo de recompensa',
        label: {
            name: 'Nom',
            email: 'Correu electrònic',
            iVRewardPromotion: 'Promoció de recompensa IV',
            balance: 'Saldo',
            status: 'Estat',
            action: 'Acció',
            enabled: 'Habilitat',
            disabled: 'Deshabilitat',
            location: 'Ubicació',
            date: 'Data',
            energy: 'Energia (kWh)',
            cost: 'Cost',
            rewardPoint: 'Punt de recompensa',
            rewardSettelemant: 'Resolució de recompenses',
            description: 'Descripció',
            credit: 'Crèdit',
            debit: 'Dèbit',
            iVRewardSettelemant: 'Recompenses - Resolució',
            amount: 'Import',
            request_by: 'Sol·licitat per',
            request_date: 'Sol·licitat en',
            review_by: 'Revisada per',
            review_date: 'Revisada en',
            review_comment: 'Comentaris del revisor',
            approvalRequest: "Sol·licitud d'aprovació",
            enterComments: 'Introdueix els teus comentaris',
            transaction_date: 'Data de la transacció',
            debit_credit: 'Dèbit/Crèdit',
            type: 'Tipus',
            requested_by_comment: 'Solicitada per Comentaris',
            volts: 'Volts',
            commentsFrom: 'Comentaris de',
            approve: 'Aprovar',
            decline: 'Rebutjar',
            federatedAccount: 'Tipus de compte federat',
        },
        placeholder: {
            nameOrEmail: 'Nom/Correu electrònic',
            selectIVAwardPromotion: 'Promoció de premis selectes IV',
            selectStatus: "Selecciona l'estat",
            startDate: "Data d'inici",
            endDate: 'Data de finalització',
            description: 'Descripció',
            volts: 'Volts',
            enterComments: 'Introdueix els teus comentaris',
        },
        button: {
            search: 'Cercar',
            reset: 'Restablir',
            save: 'Desa',
            cancel: 'Cancel·lar',
            decline: 'Rebutjar',
            approve: 'Aprovar',
            send_for_approval: 'Enviar per a aprovació',
        },
        errors: {
            type: {
                required: 'Crèdit o dèbit de la resolució',
            },
            volts: {
                typeError: 'Introdueix volts vàlids',
                moreThan: 'Els volts han de ser majors/menors que 0',
            },
            status: {
                selectApprovalOrReject: 'Aprovar/Rebutjar aquesta sol·licitud.',
            },
        },
    },
    organisationdashboard: {
        title: "Tauler de l'organització: ##COMPANY_BRAND_NAME## - Plataforma de servei eMobility",
        header: "Tauler de l'organització",
        dashboard: 'Tauler',
        label: {
            filter: 'Filtrar',
            organisation: 'Organització',
            selectOrganisations: 'Selecciona les organitzacions',
            dateRange: 'Rang de dates ',
            driverGroup: 'Grups de conductors',
            drivers: 'Conductor/vehicle',
            selectDriver: 'Selecciona el conductor/vehicle',
            selectDriverGroup: 'Selecciona els grups de conductors',
            month: 'Mes',
            year: 'Any',
            day: 'Dia',
            week: 'Setmana',
            userSessionTitle: 'Sessions del conductor',
            userSessions: 'Sessions del conductor ',
            totalIncomeTitle: 'Suma de ingressos',
            income: 'Ingressos',
            energy: 'Energia ',
            energyTitle: "Suma d'energia (kWh)",
            selectAll: 'Selecciona-ho tot',
            totalRFIDCards: 'Total de targetes RFID',
            available: 'Disponible',
            allocated: 'Assignat',
            duplicate: 'Duplicat',
            disabled: 'Deshabilitat',
            rfid: 'RFID',
            totalDriverAccounts: 'Comptes totals del conductor',
            driver: 'Conductors',
            enabled: 'Habilitat ',
            pending: 'Pendent ',
            deleted: 'Eliminat',
            topTenDriverVehicles: 'Els 10 conductors/vehicles més utilitzats',
            driverAccount: 'Conductor',
            vehicle: 'Vehicle',
            driverName: 'Nom del conductor',
            vehicleNumber: 'Número del vehicle',
            kwhUsage: 'Ús de kWh',
            dateRangeLabel: 'Rang de dates:',
            both: 'Ambdós',
            nameorvehicleno: 'Nom/Núm. de vehicle',
            type: 'Tipus',
        },
        button: {
            apply: 'Aplicar',
            clear: 'Netejar',
            syncData: 'Sincronitzar dades',
            search: 'Cercar',
            reset: 'Restablir',
        },
    },
    organisationtransactions: {
        headerTitle:
            "Transaccions de l'organització - ##COMPANY_BRAND_NAME##: Càrrega ràpida de vehicles elèctrics al Regne Unit",
        invoiceHeader:
            'Detall de la factura - ##COMPANY_BRAND_NAME##: Càrrega ràpida de vehicles elèctrics al Regne Unit',
        invoiceTitle: 'Detall de la factura',
        title: "Transaccions de l'organització",
        transaction: 'Transacció',
        columns: {
            location: 'Ubicació',
            date: 'Data',
            time: 'Temps',
            cost: 'Cost',
            energy: 'Energia ',
            action: 'Acció',
            remark: 'Observacions',
            amount: 'Import',
            closing: 'Tancament',
            transaction: 'Identificador de transacció',
            name: 'Nom',
            credit: 'Crèdit',
            debit: 'Dèbit',
            vehicleNumber: 'Número del vehicle',
            invoiceNumber: 'Número de la factura',
            comment: 'Comentari',
            startDate: "Data d'inici",
            endDate: 'Data de finalització',
        },
        csvHeader: {
            transaction: 'Transaction_ID',
            publicCardId: 'Public_Card_ID',
            stationId: 'Station_ID',
            transactionStartDate: 'Transaction_Start_Date',
            transactionEndDate: 'Transaction_End_Date',
            stationAddress: 'Station_Address',
            driverAccountId: 'Driver_Account_ID',
            vat_amount: 'VAT_Amount',
            stationName: 'Station_Name',
            kwh: 'kWh_Delivered',
            price_per_kwh: 'Price_Per_kWh',
            net_value: 'Net_Value',
            vat_rate: 'VAT_Rate',
            gross_value: 'Gross_Value',
            invoiceNumber: 'Invoice_Number',
            driverName: 'Driver_Name',
        },
        form: {
            charge: 'Carregant',
            payment: 'Pagament',
            month: 'Mes',
        },
        label: {
            exportAll: 'Exporta-ho tot',
            amount: 'Import',
            driverName: 'Número de conductor/vehicle',
            station: 'Estació',
            kwh: 'kWh',
            price_per_kwh: 'Preu/kWh',
            net_value: 'Valor net',
            vat_rate: "Taxa de l'IVA",
            gross_value: 'Valor brut',
            totalBeforeVAT: "Total abans de l'IVA",
            VatAt: ' IVA al',
            VatRate: "Taxa de l'IVA:",
            totalNetAmount: 'Total import net',
            subTotal: 'Subtotal',
            adjustedAmount: 'Quantitat ajustada',
            grandTotal: 'Total acumulat',
            totalFee: ' Total de taxes',
            invoiceNumber: 'Número de la factura',
            invoiceDate: 'Data de la factura',
            transaction: 'Identificador de transacció',
            name: 'Nom',
            date: 'Data',
            publicCardId: 'ID de la targeta RFID pública',
            stationId: "Identificador de l'estació",
            transactionStartDate: "Data d'inici de la transacció",
            transactionEndDate: 'Data de finalització de la transacció',
            stationAddress: "Adreça de l'estació",
            driverAccountId: 'Identificador del compte del conductor',
            vat_amount: "Import de l'IVA",
            stationName: "Nom de l'estació",
            status: 'Estat',
        },
        button: {
            search: 'Cercar',
            reset: 'Restablir',
            back: 'Enrere',
            export: 'Exportar',
        },
        placeholder: {
            startDate: "Data d'inici",
            endDate: 'Data de finalització',
            startDateFrom: "Data d'inici des de",
            startDateTo: "Data d'inici fins a",
            select: {
                organisation: "Selecciona l'organització",
                invoice: 'Selecciona el número de factura',
            },
        },
        message: {
            noDataToExport: 'No hi ha dades per exportar.',
            organisation: {
                required: "Selecciona l'organització",
            },
            selectRecordToExport: 'Selecciona qualsevol registre per exportar.',
        },
    },
    driverVehicleAccount: {
        title: 'Comptes de conductors/vehicles: ##COMPANY_BRAND_NAME## - Plataforma de serveis eMobility',
        header: 'Comptes de conductors/vehicles',
        managedriver: 'Gestionar conductor/vehicle ',
        importHeader: 'Pujar nous comptes amb targetes RFID',
        importUpdateStatusHeader: 'Habilitar/Desactivar comptes',
        importUpdateSpendGroupAssociation: "Actualitzar l'Associació del Grup de Límit de Despesa del Conductor",
        placeholder: {
            name: 'Nom/ Correu electrònic / Núm. de vehicle',
            rfidCardNo: 'Núm. de targeta RFID',
            driverGroups: 'Selecciona els grups de conductors',
            status: "Selecciona l'estat",
            first_name: 'Nom',
            last_name: 'Cognom',
            email: 'Adreça de correu electrònic',
            vehicle_no: 'Vehicle núm.',
            driverGroup: 'Selecciona els grups de conductors',
            accountType: 'Selecciona el tipus de compte',
            publicRFIDCardNo: 'Introdueix el núm. de la targeta RFID pública',
            languagePreference: "Preferència d'idioma",
        },
        label: {
            name: 'Nom',
            email: 'Correu electrònic',
            vehicleNo: 'Vehicle núm.',
            group: 'Grup',
            createdDate: 'Data de creació',
            status: 'Estat',
            action: 'Acció',
            enabled: 'Habilitat',
            disabled: 'Deshabilitat',
            cancelled: 'Cancel·lat',
            deleted: 'Eliminat',
            delete: 'Eliminar',
            first_name: 'Nom',
            last_name: 'Cognom',
            vehicle_no: 'Vehicle núm.',
            driverGroup: 'Grups de conductors',
            accountType: 'Tipus de compte',
            assignRFIDCard: 'Assignar targeta RFID',
            rfidCard: 'Targeta RFID',
            publicRFIDCardNo: 'Introdueix el núm. de la targeta RFID pública',
            assign: 'Assignar',
            allocatedRFIDCards: 'Targetes RFID assignades',
            file: 'Fitxer CSV',
            clickHere: 'Feu clic aquí',
            downloadTemplate: 'per descarregar la plantilla',
            errosInImportedFile: 'Errors',
            driverVehicleNo: 'Número de conductor/vehicle',
            driverVehicleDetails: 'Detalls de conductor/vehicle',
            error: 'Error',
            pending: 'Pendent ',
            card_allocated: 'Targeta RFID assignada',
            driver: "Conductor (compte basat en l'aplicació Fleet)",
            vehicle: 'Vehicle (compte basat en RFID)',
            note: 'Nota: ',
            accountSetupNote:
                "L'usuari del compte haurà de completar la configuració del compte dins de les 24 hores a través de l'aplicació Fleet de ##COMPANY_BRAND_NAME## utilitzant la contrasenya temporal proporcionada per correu electrònic.",
        },
        button: {
            import: 'Importar',
            add: 'Afegir',
            search: 'Cercar',
            reset: 'Restablir',
            edit: 'Editar',
            enable: 'Habilitar',
            disable: 'Deshabilitar',
            delete: 'Eliminar',
            yes: 'Sí',
            no: 'No',
            back: 'Enrere',
            save: 'Desa',
            cancel: 'Cancel·lar',
            assignRFIDCard: 'Assignar targeta RFID',
            assign: 'Assignar',
            action: 'Acció',
            done: 'Fet',
            sendEmail: 'Envia un correu electrònic',
            enableDisableAccounts: 'Habilitar/Desactivar comptes',
            export: 'Exportar',
        },
        message: {
            deleteConfirmMesage: 'Estàs segur que el vols eliminar?',
            enableConfirmMesage: 'Estàs segur que el vols habilitar?',
            disableConfirmMesage: 'Estàs segur que el vols deshabilitar?',
            sendMailConfirmMessage: 'Estàs segur que vols enviar un correu electrònic?',
            mailSentSuccessMessage: 'Correu electrònic enviat amb èxit.',
        },
        errors: {
            invalidEmail: 'Introdueix una adreça de correu electrònic vàlida.',
            invalidFirstName: 'Introdueix un nom vàlid.',
            invalidLastName: 'Introdueix un cognom vàlid.',
            invalidVehicleNo: 'Introdueix un núm. de vehicle vàlid',
            common: 'Alguna cosa ha anat malament, intenta-ho de nou.',
        },
        account_type: {
            driver: 'Conductor',
            vehicle: 'Vehicle',
        },
        columns: {
            public_rfid_card_no: 'Núm. de targeta',
            allocatedBy: 'Assignada per',
            allocatedDate: 'Data assignada',
            status: 'Estat',
        },
    },
    chargingHistory: {
        header: 'Sessions de càrrega - ##COMPANY_BRAND_NAME##: Càrrega ràpida de vehicles elèctrics al Regne Unit',
        title: 'Sessions de càrrega',
        label: {
            exportAll: 'Exportar',
            location: 'Ubicació',
            date: 'Data',
            milesAdded: 'Milles afegides',
            time: 'Temps',
            cost: 'Cost',
            energy: 'Energia',
            action: 'Acció',
            remark: 'Observacions',
            name: 'Nom',
            vehicleNo: 'Vehicle núm.',
        },
        button: {
            search: 'Cercar',
            reset: 'Restablir',
            back: 'Enrere',
        },
        placeholder: {
            startDate: "Data d'inici",
            endDate: 'Data de finalització',
            startDateFrom: "Data d'inici des de",
            startDateTo: "Data d'inici fins a",
            driver: 'Nom/ Correu electrònic / Núm. de vehicle',
            selectDriverGroup: 'Selecciona els grups de conductors/vehicles',
        },
        errors: {
            noDataToExport: 'No hi ha dades per exportar.',
            selectRecordToExport: 'Selecciona qualsevol registre per exportar.',
            common: 'Alguna cosa ha anat malament, intenta-ho de nou.',
        },
    },
    paymentHistory: {
        header: 'Històric de pagament - ##COMPANY_BRAND_NAME##: Càrrega ràpida de vehicles elèctrics al Regne Unit',
        title: 'Històric de pagament',
        invoiceHeader:
            'Detall de la factura - ##COMPANY_BRAND_NAME##: Càrrega ràpida de vehicles elèctrics al Regne Unit',
        invoiceTitle: 'Detall de la factura',
        label: {
            remark: 'Observacions',
            credit: 'Crèdit',
            debit: 'Dèbit',
            closing: 'Tancament',
            transaction: 'Identificador de transacció',
            name: 'Nom',
            date: 'Data',
            amount: 'Import',
            driverName: 'Número de conductor/vehicle',
            station: 'Estació',
            kwh: 'kWh',
            price_per_kwh: 'Preu/kWh',
            net_value: 'Valor net',
            vat_rate: "Taxa de l'IVA",
            gross_value: 'Valor brut',
            totalBeforeVAT: "Total abans de l'IVA",
            VatAt: ' IVA al',
            totalFee: ' Total de taxes',
            invoiceNumber: 'Número de la factura',
            invoiceDate: 'Data de la factura',
            publicCardId: 'ID de la targeta RFID pública',
            stationId: "Identificador de l'estació",
            transactionStartDate: "Data d'inici de la transacció",
            transactionEndDate: 'Data de finalització de la transacció',
            stationAddress: "Adreça de l'estació",
            driverAccountId: 'Identificador del compte del conductor',
            vat_amount: "Import de l'IVA",
            stationName: "Nom de l'estació",
        },
        csvHeader: {
            transaction: 'Transaction_ID',
            publicCardId: 'Public_Card_ID',
            stationId: 'Station_ID',
            transactionStartDate: 'Transaction_Start_Date',
            transactionEndDate: 'Transaction_End_Date',
            stationAddress: 'Station_Address',
            driverAccountId: 'Driver_Account_ID',
            vat_amount: 'VAT_Amount',
            stationName: 'Station_Name',
            kwh: 'kWh_Delivered',
            price_per_kwh: 'Price_Per_kWh',
            net_value: 'Net_Value',
            vat_rate: 'VAT_Rate',
            gross_value: 'Gross_Value',
            invoiceNumber: 'Invoice_Number',
            driverName: 'Driver_Name',
        },
        placeholder: {
            startDate: "Data d'inici",
            endDate: 'Data de finalització',
        },
        button: {
            search: 'Cercar',
            reset: 'Restablir',
            export: 'Exportar',
        },
        errors: {
            noDataToExport: 'No hi ha dades per exportar.',
            selectRecordToExport: 'Selecciona qualsevol registre per exportar.',
        },
    },
    configurations: {
        title: 'Configuracions: ##COMPANY_BRAND_NAME## - Plataforma de servei eMobility',
        header: 'Configuracions',
        columns: {
            name: 'Nom',
            value: 'Valor',
            description: 'Descripció',
            system_type: 'Tipus de sistema',
            modifiedBy: 'Modificat per',
            modifiedDate: 'Data de modificació',
            action: 'Acció',
        },
        button: {
            save: 'Desa',
            cancel: 'Cancel·lar',
            reset: 'Restablir',
            search: 'Cercar',
            action: 'Acció',
            edit: 'Editar',
        },
        note: "ADVERTÈNCIA: Canviar aquestes configuracions pot impactar significativament el rendiment de la plataforma. Si tens cap dubte, posa't en contacte amb l'administrador del sistema.",
        errors: {
            maxLengthString: 'Introdueix un valor amb un màxim de',
            maxLengthStringCharacters: 'caràcters',
            maxLengthNUmberCharacters: 'dígits',
            valueBetween: 'Introdueix un valor entre  ',
            valueGraterThen: 'Introdueix un valor igual o superior a',
            valueMention: 'Introdueix un valor dins del rang esmentat',
        },
        placeholder: {
            value: 'Introdueix un valor',
            description: 'Introdueix una descripció',
            name: 'Nom',
            valueSearch: 'Valor',
            descriptionSearch: 'Descripció',
            referenceCode: 'Codi de referència',
            systemType: 'Seleccionar el tipus de sistema',
        },
        label: {
            value: 'Valor',
            dataType: 'Tipus de dada',
            description: 'Descripció',
            system: 'SISTEMA',
            driver: 'CONDUCTOR',
            admin: 'ADMINISTRADOR',
            referenceCode: 'Codi de referència',
        },
    },
    rfidRequests: {
        title: 'Sol·licituds de targetes RFID - ##COMPANY_BRAND_NAME##: Càrrega ràpida de vehicles elèctrics al Regne Unit',
        header: 'Sol·licituds de targetes RFID',
        placeholder: {
            nameEmail: 'Nom/Correu electrònic',
            startDate: "Data d'inici",
            endDate: 'Data de finalització',
            publicCardNo: 'Introdueix el número de targeta pública',
            enterComments: 'Introdueix els teus comentaris',
            status: "Selecciona l'estat",
            publicRFIDCardNo: 'Introdueix el núm. de la targeta RFID pública',
            scanReqQR: 'Escaneja el codi QR imprès a la carta',
        },
        button: {
            search: 'Cercar',
            reset: 'Restablir',
            save: 'Desa',
            cancel: 'Cancel·lar',
            add: 'Afegir',
            done: 'Fet',
            action: 'Acció',
            assign: 'Assignar',
            downloadPdf: 'Descarregar sol·licituds en PDF',
            downloadPdfSelected: 'Descarregar PDF per a les sol·licituds seleccionades',
            downloadPendingApprovedPdf: 'Descarregar totes les sol·licituds pendents i aprovades en PDF',
        },
        columns: {
            name: 'Nom',
            email: 'Correu electrònic',
            requestedDate: 'Data de sol·licitud',
            noofCardReq: 'Número de targeta sol·licitada',
            noofCardAllocated: 'Número de targeta assignada',
            requestStatus: 'Estat de la sol·licitud',
            status: 'Estat',
            driverStatus: 'Estat del conductor',
            action: 'Acció',
            public_rfid_card_no: 'Núm. de targeta',
            allocatedBy: 'Assignada per',
            allocatedDate: 'Data assignada',
            federated_account_type: 'Tipus de compte federat',
        },
        label: {
            reviewRequest: 'Revisar sol·licitud',
            assignRFID: 'Targeta RFID',
            processRFIDRequest: 'Processar sol·licitud',
            noofCardRequested: 'Número de targeta sol·licitada',
            noofCardAllocated: 'Número de targeta assignada',
            approved: 'Aprovar',
            declined: 'Rebutjar',
            publicCardNo: 'Introdueix el número de targeta pública',
            enterComments: 'Introdueix els teus comentaris',
            requestStatus: 'Estat de la sol·licitud',
            assignRFIDCards: 'Assignar targetes RFID',
            publicRFIDCardNo: 'Introdueix el núm. de la targeta RFID pública',
            allocatedRFIDCards: 'Targetes RFID assignades',
            address: 'Adreça',
            scanReqQR: 'Escaneja el codi QR imprès a la carta',
            name: 'Nom',
            requestId: 'Identificador de sol·licitud',
            scanHistory: "Històric d'escaneig",
        },
        message: {
            requestProcessed: 'Sol·licitud processada amb èxit',
        },
        errors: {
            approveReject: 'Aprova/rebutja aquesta sol·licitud.',
            selectAnyRecord: 'Selecciona almenys un registre per descarregar PDF.',
            reqNumTypeError: 'Introdueix un identificador de sol·licitud vàlid',
        },
        pdfText: {
            dear: 'Estimat',
            instavolt: ' ##COMPANY_BRAND_NAME##',
            companyNumber: "Número d'empresa",
            line1: "Gràcies per sol·licitar la teva targeta RFID mitjançant l'aplicació de ##COMPANY_BRAND_NAME##, trobaràs la teva targeta adjunta.",
            line2: 'Per activar la targeta, segueix els passos següents:',
            step1: "1. Inicia la sessió a l'aplicació.",
            step2: "2. En el menú, selecciona 'Configuració'",
            step3: "3. Fes clic a l'opció 'Les meves targetes RFID'",
            step4: "4. Fes clic al botó 'Afegir targeta RFID'",
            step5: "5. Introdueix el número de la targeta imprès a la targeta i prem el botó 'Procedir'",
            step6: '6. La teva targeta està ara activada i es pot utilitzar per iniciar la teva propera sessió de càrrega.',
            line3: 'Sabies que pots guanyar recompenses cada vegada que carregues? Rep un Volt per cada kWh utilitzat i un cop hagis acumulat suficients Volts, aquests es poden canviar i utilitzar per comprar sessions de càrrega a la xarxa.',
            line4: 'Gràcies per carregar amb nosaltres.',
            line5: "L'equip de ##COMPANY_BRAND_NAME##",
            line6: 'Brindant una infraestructura de càrrega de vehicles elèctrics de classe mundial al Regne Unit.',
        },
    },
    RFIDCardFleets: {
        title: 'Targetes RFID: ##COMPANY_BRAND_NAME## - Plataforma de servei eMobility',
        header: 'Targetes RFID',
        placeholder: {
            name: 'Nom del conductor/ Correu electrònic / Número de vehicle',
            manufacturer: 'Fabricant',
            public_card_id: 'Identificador de la targeta pública',
            status: "Selecciona l'estat",
            mifare_uid: 'UID Mifare',
        },
        label: {
            name: 'Nom',
            manufacturer: 'Fabricant',
            part_id: 'Identificador de la part',
            public_card_id: 'Identificador de la targeta pública',
            private_card_id: 'Identificador de la targeta privada',
            created_date: 'Data de creació',
            status: 'Estat',
            action: 'Acció',
            enabled: 'Habilitat ',
            disabled: 'Deshabilitat',
            delete: 'Eliminar',
            remove: 'Eliminar associació',
            reinstate: 'Reiniciar',
            activated: 'Activada',
            available: 'Disponible',
            duplicate: 'Duplicat',
        },
        button: {
            search: 'Cercar',
            cancel: 'Cancel·lar',
            add: 'Afegir',
            assing: 'Assignar targeta RFID',
            import: 'Importar arxiu',
            save: 'Desa',
            edit: 'Editar',
            reset: 'Restablir',
            yes: 'Sí',
            no: 'No',
            enabled: 'Habilitar',
            disabled: 'Deshabilitar',
            action: 'Acció',
            back: 'Enrere',
            enable: 'Habilitar',
            disable: 'Deshabilitar',
            getCredentials: 'Obtén credencials',
            delete: 'Eliminar',
            remove: 'Eliminar associació',
            reinstate: 'Reiniciar',
            exportAll: 'Exporta-ho tot',
        },
        message: {
            enableConfirmMesage: 'Estàs segur que el vols habilitar?',
            disableConfirmMesage: 'Estàs segur que el vols deshabilitar?',
            deleteConfirmMesage: 'Estàs segur que el vols eliminar?',
            removeConfirmMesage: "Segur que vols eliminar l'associació de la targeta RFID a un compte?",
            reinstateConfirmMessage: 'Segur que vols reactivar la targeta RFID?',
        },
        insert: {
            header: 'Gestiona les targetes RFID',
            placeholder: {
                manufacturer: 'Nom del fabricant',
                part_id: 'Identificador de la part',
                public_card_id: 'Identificador de la targeta pública',
                private_card_id: 'Identificador de la targeta privada',
                mifare_uid: 'UID Mifare',
            },
            label: {
                manufacturer: 'Fabricant',
                part_id: 'Identificador de la part',
                public_card_id: 'Identificador de la targeta pública',
                private_card_id: 'Identificador de la targeta privada',
                mifare_uid: 'UID Mifare',
            },
            errors: {
                common: 'Alguna cosa ha anat malament, intenta-ho de nou.',
                name: {
                    valid: 'Introdueix un nom vàlid',
                },
                code: {
                    valid: 'Introdueix un codi vàlid',
                },
                url: {
                    valid: 'La URL ha de ser una URL vàlida',
                },
            },
        },
        assignCards: {
            header: 'Assignar targeta RFID',
            label: {
                driver: 'Conductor/vehicle',
            },
            button: {
                yes: 'Assignar',
                no: 'Cancel·lar ',
            },
            form: {
                driver: 'Conductor/vehicle',
                placeholder: {
                    driver: 'Selecciona el conductor/vehicle',
                },
            },
        },
        disableCards: {
            header: 'Deshabilitar',
            header2: 'Estàs segur que el vols deshabilitar?',
            placeholder: {
                comment: 'Introdueix un comentari',
            },
            label: {
                comment: 'Comentari',
            },
            button: {
                yes: 'Sí',
                no: 'No',
            },
        },
        importCards: {
            header: 'Importar targetes RFID',
            placeholder: {
                file: 'Selecciona el fitxer CSV',
            },
            label: {
                file: 'Fitxer CSV',
            },
            button: {
                yes: 'Importar',
                no: 'Cancel·lar ',
            },
            errors: {
                common: 'Alguna cosa ha anat malament, intenta-ho de nou.',
                file: {
                    fileType: "Es poden carregar arxius amb extensió '.csv'.",
                },
            },
        },
        importCardsDetails: {
            header: 'Detalls de la importació de targetes RFID',
            label: {
                unSuccessfullImport: 'Les següents targetes no es poden importar',
                successfullImport: 'Les següents targetes s’han importat correctament',
                failerReason: 'Motiu de la fallada',
                publicCardId: 'ID de targeta pública',
            },
            message: {
                defualtErrorMessage: 'Hi ha un problema en importar les targetes següents.',
            },
        },
    },
    myProfile: {
        title: 'El meu perfil: ##COMPANY_BRAND_NAME## - Plataforma de servei eMobility',
        header: 'El meu perfil',
        subheader: {
            details: 'Dades personals',
            security: 'Seguretat',
            password: 'Contrasenya',
        },
        label: {
            firstName: 'Nom',
            lastName: 'Cognom',
            email: 'Correu electrònic',
            phoneNo: 'Núm Telèfon.',
            currentPassword: 'Contrasenya actual',
            newPassword: 'Nova contrasenya',
            confirmPassword: 'Torna a confirmar la contrasenya',
            mfaAuthentication: 'Autenticació 2FA',
            authentication: 'Autenticació',
            securityCode: 'Codi de seguretat',
            languagePreference: "Preferència d'idioma",
        },
        placeholder: {
            firstName: 'Nom',
            lastName: 'Cognom',
            email: 'Correu electrònic',
            phoneNo: 'Núm. Telèfon.',
            currentPassword: 'Contrasenya actual',
            newPassword: 'Nova contrasenya',
            confirmPassword: 'Torna a confirmar la contrasenya',
            securityCode: 'Codi de seguretat',
            languagePreference: "Preferència d'idioma",
        },
        button: {
            save: 'Desa',
            cancel: 'Cancel·lar',
            update: 'Actualitzar',
            ok: "D'acord",
        },
        toast: {
            profileSuccess: 'Perfil actualitzat correctament.',
            profileError: 'El perfil no està actualizat. Intenta-ho de nou.',
            passwordChange: 'Contrasenya canviada correctament.',
            passwordErr: "La contrasenya no s'ha canviat correctament. Intenta-ho de nou.",
            passwordWrong: 'La contrasenya actual és incorrecta.',
            securityStop: "L'autenticació de 2FA s'ha detingut.",
            error: 'Alguna cosa ha anat malament. Intenta-ho de nou.',
            securitySetupSuccess: "L'autenticació de 2FA s'ha configurat correctament.",
            securitySetupError: "L'autenticació de 2FA no s'ha configurat correctament. Prova-ho de nou més tard.",
            securityCodeInvalid: 'Codi de seguretat no vàlid.',
        },
        errors: {
            securityCode: {
                match: 'Introdueix un codi vàlid',
                inValid: 'Introdueix un codi de 6 dígits',
            },
            password: {
                confirmPasswordMatch: 'La nova contrasenya i la confirmació de la contrasenya no coincideixen.',
            },
        },
    },
    apiCredentials: {
        title: 'Credencials API: ##COMPANY_BRAND_NAME## - Plataforma de servei eMobility',
        header: 'Credencials API',
        button: {
            generate: 'Genera Fitxa',
            regenerate: 'Regenerar Fitxa',
            yes: 'Sí',
            no: 'No',
        },
        note_no_permission:
            "No tens drets per accedir a l'API. Contacta amb l'administrador de ##COMPANY_BRAND_NAME## per obtenir accés.",
        note_generte_token:
            'Pots generar la fitxa fent clic a "Generar fitxa" i pots utilitzar aquesta fitxa per accedir a l\'API.',
        note: 'Pots regenerar la fitxa fent clic a "Regenerar fitxa" i pots utilitzar aquesta fitxa per accedir a l\'API.',
        label: {
            token: 'Fitxa',
            generate: 'Genera Fitxa',
            regenerate: 'Regenerar Fitxa',
        },
        message: {
            regenerateConfirmMesage:
                "Estàs segur que vols regenerar el token? <br/> Un cop regeneris el token, l'antic serà invàlid i no podràs accedir a l'API amb l'antic.",
            generateConfirmMesage: 'Estàs segur que vols generar el token?',
        },
    },
    cookiePolicy: {
        text: "Aquest lloc web utilitza cookies per millorar l'experiència de l'usuari. Utilitzant el nostre web, reconeixes que has llegit i entès la nostra",
        action: 'Política de cookies',
        iAccept: 'Accepto',
    },
    paymentconfig: {
        title: 'Pagament - ##COMPANY_BRAND_NAME##: Càrrega ràpida de vehicles elèctrics al Regne Unit',
        header: 'Pagament',
        processingNote: "Espera mentre la teva transacció s'està processant",
        purchaseOrderNote:
            'Tens un cicle de facturació de ##PAYMENT_SCHEDULE##. La teva propera data de facturació serà: ',
        description: 'Pagament a ##COMPANY_BRAND_NAME##:',
        note: "La feina en segon pla s'executarà cada setmana per saldar les factures pendents de la càrrega de vehicles elèctrics realitzada pels conductors/vehicles ",
        addReplaceCardNote:
            'Tingues en compte que en afegir una targeta de pagament, el teu compte serà debitat amb ##CURRENCY_SYMBOL_WITH_VALUE##, que es carregarà al saldo del teu moneder de ##COMPANY_BRAND_NAME##.',
        label: {
            currentBalance: 'Saldo actual',
            closingBalance: 'Saldo a tancar',
            availableCredit: 'Crèdit disponible',
            unbilledAmount: 'Import no facturat',
            cardTitle: 'Nom a la targeta',
            cardNumber: 'Número de la targeta',
            expiry: 'Caducitat',
            note: 'Nota: ',
            CSC: 'CSC',
            cardSecurityCode: '(Codi de seguretat de la targeta)',
            charityDonation: 'Donatiu a caritat',
            roundUp: 'Arrodonir',
            topUp: 'Recarregar',
            expires: 'Caduca',
            charity: 'Caritat',
        },
        placeholder: {
            cardTitle: 'Nom a la targeta',
            cardNumber: '1234 1234 1234 1234',
            CSC: 'CSC',
            topUpAmount: '00.00',
        },
        button: {
            save: 'Desa',
            edit: 'Editar',
            replace: 'Reemplaçar',
            back: 'Enrere',
            payNow: 'Pagar ara',
        },
        errors: {
            CSC: {
                min: 'Introdueix un codi mínim de 3 dígits.',
            },
            topupAmount: {
                min: "L'import de la caritat ha de ser igual o superior a 0.1",
            },
            cardNumber: {
                inValid: 'Número de targeta no vàlid',
            },
            commonError: 'Hi ha hagut un error processant la teva sol·licitud. Prova-ho més tard.',
            transactionFailed: 'La teva transacció ha fallat. Prova-ho de nou.  ',
        },
        message: {
            cardSaved: 'Detalls de la targeta guardats amb èxit',
        },
    },
    refundRequest: {
        title: 'Aprovacions de retirada - ##COMPANY_BRAND_NAME##: Càrrega ràpida de vehicles elèctrics al Regne Unit',
        header: 'Aprovacions de retirada',
        accountInfoNote: 'Informació del compte introduïda per dur a terme la retirada:',
        completeConfirmNote:
            "Només completa aquesta sol·licitud de retirada si has abonat l'import al compte bancari del conductor. Vols continuar?",
        bulkCompleteConfirmNote:
            "Només completa aquestes sol·licituds de retirada si has abonat l'import al compte bancari del conductor. Vols continuar?",
        declineConfirmNote:
            "Assegura't d'haver introduït un motiu adequat per rebutjar la sol·licitud, ja que aquesta informació es transmet al client.  Vols continuar?",
        bulkDeclineConfirmNote:
            "Assegura't d'haver introduït un motiu adequat per rebutjar les sol·licituds, ja que aquesta informació es transmet al client.  Vols continuar?",
        label: {
            name: 'Nom',
            reviewRequest: 'Revisar sol·licitud',
            driverName: 'Nom del conductor',
            driverEmail: 'Correu electrònic del conductor',
            requestedDate: 'Data de sol·licitud',
            action: 'Acció',
            amount: 'Import',
            refundRequested: 'Retirada sol·licitada',
            status: 'Estat',
            accountNumber: 'Número de compte',
            sortCode: 'Codi de sucursal',
            enterComments: 'Introdueix comentaris',
            pending: 'Pendent ',
            closed: 'Tancat',
            complete: 'Completar',
            decline: 'Rebutjar',
            review_by: 'Revisada per',
            review_date: 'Revisada en',
            approvalRequest: 'Aprobar sol·licitud',
            processRefundRequest: 'Processar sol·licitud de retirada',
            completeRefundRequest: 'Completar sol·licitud de retirada',
            bulkCompleteRefundRequest: 'Completar sol·licituds de retirada',
            declineRefundRequest: 'Rebutjar sol·licitud de retirada',
            bulkdeclineRefundRequest: 'Rebutjar sol·licituds de retirada',
            export: 'Exporta dades',
            bulk: 'Granel',
        },
        button: {
            decline: 'Rebutjar',
            approve: 'Aprovar',
            reset: 'Restablir',
            search: 'Cercar',
            complete: 'Completar',
            save: 'Desa',
            cancel: 'Cancel·lar',
            yes: 'Sí',
            no: 'No',
        },
        placeholder: {
            selectStatus: "Selecciona l'estat",
            enterComments: 'Introdueix comentaris',
            name: 'Nom/Correu electrònic',
        },
        errors: {
            status: {
                selectApprovalOrReject: 'Completa/rebutja aquesta sol·licitud.',
            },
            selectWithdrawalApprovals: 'Selecciona les sol·licituds de retirada',
        },
    },
    termsAndConditionListing: {
        title: 'Termes i condicions - ##COMPANY_BRAND_NAME##: Càrrega ràpida de vehicles elèctrics al Regne Unit',
        header: 'Termes i condicions',
        noteDetails: "*L'obligatori ha de ser acceptat per poder utilitzar o registrar un compte.          ",
        label: {
            iAggreeToTermsCondition: 'Accepto',
            note: 'Nota: ',
            termsAndConditions: 'Termes i condicions.',
            reviewUpdatedCondition:
                "Revisa i accepta els termes i condicions actualitzats que s'indiquen a continuació.",
            name: 'Nom',
        },
        button: {
            accept: 'Acceptar',
            next: 'Següent',
            cancel: 'Cancel·lar',
        },
        errors: {
            acceptTermCondition: 'Accepta els Termes i Condicions *obligatoris per a continuar.',
        },
    },
    adminDashboard: {
        title: 'Inici: ##COMPANY_BRAND_NAME## - Plataforma de serveis eMobility',
        header: 'Tauler',
        formtitle: 'Validació de formulari',
        label: {
            filter: 'Filtrar',
            reportTags: "Etiquetes d'informe",
            driverGroup: 'Grups de conductors',
            selectDriverGroup: 'Selecciona els grups de conductors',
            selectTags: 'Selecciona les etiquetes',
            dateRange: 'Rang de dates',
            month: 'Mes',
            year: 'Any',
            day: 'Dia',
            week: 'Setmana',
            userSessionTitle: 'Sessions del conductor',
            userSessions: 'Sessions del conductor',
            totalIncomeTitle: 'Suma de ingressos',
            income: 'Ingressos',
            transactionTitle: 'Transaccions mitjanes',
            transaction: 'Transacció',
            energy: 'Energia',
            energyTitle: "Suma d'energia (kWh) ",
            failedPaymentTitle: 'Número de pagaments fallits',
            failedPayment: 'Pagament fallit',
            driverCountTitle: 'Nombre de conductors',
            driver: 'Conductor',
            accumulatedVolts: 'Volts acumulats',
            claimedVolts: 'Volts reclamats ',
            outStandingFailPayment: 'Pagament pendent fallit',
            outStandingFailedPaymentTitle: 'Pagaments pendents fallits',
            voltsLiability: 'Responsabilitat de Volts',
            voltsAccumulatedTitle: 'Volts acumulats',
            volts: 'Volts',
            voltsClaimedTitle: 'Volts declarats',
            lapsedVolts: 'Volts vençuts',
            totalNoOfDriverAccount: 'Nombre total de comptes de conductors',
            enabled: 'Habilitat',
            disabled: 'Deshabilitat',
            badDebtor: 'Mal deutor',
            cancelled: 'Cancel·lat',
            deleted: 'Eliminat',
            fake_account: 'Compte fals',
            numberOfReferees: 'Nombre de recomanats',
            numberOfReferrers: 'Nombre de recomanants',
            referralPayment: 'Pagaments de recomanació (recomanant + recomanat)',
            referrer: 'Recomanant',
            referee: 'Recomanat',
            moneySpent: 'Diners gastats només pels recomanats',
            referralBonus: 'bonus de recomanació',
            referralPromotion: 'Promoció de referència',
            overnightAutomated: 'Automatització nocturna',
            customerManual: 'Manual del client',
            pending: 'Pendent ',
            patnerPromoClicksCount: 'Comptador de clics de promocions de socis ',
            clicksCount: 'Comptador de clics',
            clicksCountMessage:
                'Selecciona una o diverses opcions per mostrar el comptador de clics de les promocions dels socis',
            individualDrivers: 'Comptes de conductors habilitats',
            organisationDrivers: "Comptes d'organitzacions habilitats",
            individualAndOrgDriverCount: 'Comptes habilitats: Conductors vs Organitzacions',
            alerts: 'Alertes',
            alertsCountTitle: "Comptador d'alertes",
            premiumSubscriptions: 'Subscripcions premium',
            activeSubscriptions: 'Total de subscripcions premium actives',
            newSubscriptions: 'Subscripcions noves',
            cancelledSubscriptions: 'Subscripcions cancel·lades',
            subscriptions: '(Subscripcions)',
        },
        placeholder: {
            patnerPromotions: 'Selecciona una o més promocions de socis per mostrar dades',
        },
        button: {
            apply: 'Aplicar',
            clear: 'Netejar',
            syncData: 'Sincronitzar dades',
        },
    },
    footer: {
        version: 'Versió',
        copyRightText: 'Tots els drets reservats',
    },
    cardReader: {
        title: 'Lectors de targetes: ##COMPANY_BRAND_NAME## - Plataforma de servei eMobility',
        header: 'Lectors de targetes',
        manageCardReader: 'Gestionar lector de targetes',
        importHeader: 'Importar lectors de targetes',
        button: {
            import: 'Importar',
            add: 'Afegir',
            back: 'Enrere',
            save: 'Desa',
            cancel: 'Cancel·lar',
            edit: 'Editar',
            action: 'Acció',
            delete: 'Eliminar',
            search: 'Cercar',
            reset: 'Restablir',
            disable: 'Deshabilitar',
            duplicate: 'Duplicat',
            active: 'Actiu',
            chargeStation: 'Estacions de càrrega',
            yes: 'Sí',
            no: 'No',
            claimCardReader: 'Reclameu lectors de targetes no assignats',
            claim: 'Reclamació',
        },
        label: {
            description: 'Descripció',
            latitude: 'Latitud',
            longitude: 'Longitud',
            serialNumber: 'Número de sèrie',
            endPoint: 'Punt final',
            createdDate: 'Data de creació',
            status: 'Estat',
            action: 'Acció',
            delete: 'Eliminar',
            csvFile: 'Fitxer CSV',
            clickHere: 'Feu clic aquí',
            downloadTemplate: 'per descarregar la plantilla',
            evse_id: 'ID EVSE',
            error: 'Error',
            errorDetail: "Detalls de l'error",
            failureReason: 'Motiu del fracàs',
            id: 'ID del lector de targetes',
        },
        placeholder: {
            description: 'Descripció',
            latitude: 'Latitud',
            longitude: 'Longitud',
            serialNumber: 'Número de sèrie',
            endPoint: 'Anul·lar punt final',
            selectStatus: "Selecciona l'estat",
        },
        errors: {
            latitude: {
                min: "La latitud ha d'estar entre -90.0 i 90.0",
                max: "La latitud ha d'estar entre -90.0 i 90.0",
                number: 'La latitud ha de ser un número',
            },
            longitude: {
                min: "La longitud ha d'estar entre -180.0 i 180.0",
                max: "La longitud ha d'estar entre -180.0 i 180.0",
                number: 'La longitud ha de ser un número',
            },
            serial_number: {
                valid: 'Introdueix un número de sèrie vàlid',
            },
        },
        message: {
            deleteConfirmMesage: 'Estàs segur que el vols eliminar?',
            duplicateConfirmMesage: 'Estàs segur que el vols duplicar?',
            disableConfirmMesage: 'Estàs segur que el vols deshabilitar?',
            activeConfirmMesage: 'Estàs segur que el vols activar?',
        },
        assign: {
            header: 'Estacions de càrrega',
            headerModal: 'Estació de càrrega',
            placeholder: {
                name: 'Introdueix el nom',
                address: 'Adreça',
                tags: 'Selecciona les etiquetes',
            },
            label: {
                add: 'Afegir',
                address: 'Adreça',
                city: 'Ciutat',
                name: 'Nom',
                type: 'Tipus',
                physical_reference: 'Referència física',
                postcode: 'Codi postal',
                action: 'Acció',
                delete: 'Eliminar',
            },
            button: {
                delete: 'Eliminar',
            },
            message: {
                deleteConfirmMesage: 'Estàs segur que el vols eliminar?',
            },
        },
    },
    cardScheme: {
        title: 'Estructures de targetes: ##COMPANY_BRAND_NAME## - Plataforma de servei eMobility',
        header: 'Estructures de targetes',
        manageCardScheme: "Gestionar l'estructura de targetes",
        label: {
            TransIdSeed: "Semenador de l'identificador de transacció",
            keybEncrKey: 'Clau de xifratge KeyB',
            transIdEncrKey: "Clau de xifratge de l'identificador de transacció",
            emspCode: 'Codi EMSP',
            endPoint: 'Punt final',
            createdDate: 'Data de creació',
            status: 'Estat',
            action: 'Acció',
            delete: 'Eliminar',
            enabled: 'Habilitat',
            disabled: 'Deshabilitat',
        },
        button: {
            import: 'Importar',
            add: 'Afegir',
            back: 'Enrere',
            save: 'Desa',
            cancel: 'Cancel·lar',
            edit: 'Editar',
            action: 'Acció',
            delete: 'Eliminar',
            search: 'Cercar',
            reset: 'Restablir',
            disable: 'Deshabilitar',
            enable: 'Habilitar',
        },
        message: {
            deleteConfirmMesage: 'Estàs segur que el vols eliminar?',
            disableConfirmMesage: 'Estàs segur que el vols deshabilitar?',
            enableConfirmMesage: 'Estàs segur que el vols habilitar?',
        },
        placeholder: {
            emspCode: 'Codi EMSP',
            keybEncrKey: 'Clau de xifratge KeyB',
            transIdEncrKey: "Clau de xifratge de l'identificador de transacció",
            TransIdSeed: "Semenador de l'identificador de transacció",
        },
        errors: {
            emsp_code: {
                valid: 'Introdueix un codi EMSP vàlid',
            },
            transaction_id_seed: {
                valid: 'Introdueix un identificador de transacció vàlid',
                min: "El semenador de l'identificador de transacció no pot ser inferior a 0",
                max: "S'ha arribat al límit màxim per al semenador de l'identificador de transacció",
            },
        },
    },
    fleetProfile: {
        orgProfile: "Perfil de l'organització",
        message: {
            success: "El perfil de l'organització s'ha actualitzat correctament",
        },
    },
    dataAggregator: {
        title: 'Agregadors de dades: ##COMPANY_BRAND_NAME## - Plataforma de servei eMobility',
        header: 'Agregadors de dades',
        button: {
            add: 'Afegir',
            search: 'Cercar',
            reset: 'Restablir',
            enable: 'Habilitar',
            disable: 'Deshabilitar',
            edit: 'Editar',
            yes: 'Sí',
            no: 'No',
            action: 'Acció',
            back: 'Enrere',
            save: 'Desa',
            cancel: 'Cancel·lar',
            syncDataAggregatorAPIKeys: "Sincronitza les claus API amb els plans d'ús",
        },
        placeholder: {
            name: 'Nom',
            status: "Selecciona l'estat",
        },
        label: {
            enabled: 'Habilitat',
            disabled: 'Deshabilitat',
            name: 'Nom',
            party_id: 'Identificador de la part',
            country_code: 'Codi del país',
            version_url: 'URL de la versió',
            created_date: 'Data de creació',
            status: 'Estat',
            action: 'Acció',
        },
        message: {
            enableConfirmMesage: 'Estàs segur que el vols habilitar?',
            disableConfirmMesage: 'Estàs segur que el vols deshabilitar?',
        },
        insert: {
            header: "Gestionar l'agregador de dades",
            errors: {
                common: 'Alguna cosa ha anat malament, intenta-ho de nou.',
                name: {
                    valid: "Introdueix un nom d'agregador de dades vàlid",
                },
                party_id: {
                    valid: 'Introdueix una ID de part vàlida',
                },
                country_code: {
                    valid: 'Introdueix un codi de país vàlid',
                },
                version_url: {
                    url: 'La URL de la versió ha de ser una URL vàlida',
                },
                token: {
                    valid: 'Introdueix una fitxa vàlida',
                },
            },
            placeholder: {
                name: 'Nom',
                party_id: 'Identificador de la part',
                country_code: 'Codi del país',
                version_url: "URL de versió de l'agregador de dades",
                token_a: 'Fitxa A',
                token_b: 'Fitxa B',
                token_c: 'Fitxa C',
                emsp: 'EMSP',
                access_group: "Grup d'accés",
                usagePlan: "Pla d'ús",
            },
            label: {
                name: 'Nom',
                party_id: 'Identificador de la part',
                country_code: 'Codi del país',
                version_url: 'URL de la versió',
                emsp: 'EMSP',
                token_a: 'Fitxa A',
                token_b: 'Fitxa B',
                token_c: 'Fitxa C',
                allow_locations_to_be_extracted: 'Només permet extreure ubicacions dels EMPS',
                allow_receive_location_update:
                    "Permetre rebre actualitzacions de localització PUT (arrencada inicial) i PATCH (actualització d'estat)",
                access_group: "Grup d'accés",
                allow_tariff_extraction: 'Inclòs Tarifa',
                usagePlan: "Pla d'ús",
            },
        },
    },
    accessGroups: {
        title: "Grups d'accés: ##COMPANY_BRAND_NAME## - Plataforma de serveis eMobility",
        header: "Grups d'accés",
        manageAccessGroup: "Gestionar el grup d'accés",
        label: {
            createdDate: 'Data de creació',
            status: 'Estat',
            action: 'Acció',
            delete: 'Eliminar',
            enabled: 'Habilitat',
            disabled: 'Deshabilitat',
            name: 'Nom',
            description: 'Descripció',
            access_control_type: "Tipus de control d'accés",
            allow_public_access: "Permetre l'accés públic",
            managed_by_organisation: "Gestionat per l'organització",
            override_tariff: 'Anular tarifa',
            yes: 'Sí',
            no: 'No',
            access_code: "Codi d'accés",
            deleted: ' (Eliminat)',
        },
        button: {
            enable: 'Habilitar',
            disable: 'Deshabilitar',
            action: 'Acció',
            edit: 'Editar',
            delete: 'Eliminar',
            enabled: 'Habilitat',
            disabled: 'Deshabilitat',
            add: 'Afegir',
            search: 'Cercar',
            reset: 'Restablir',
            back: 'Enrere',
            save: 'Desa',
            cancel: 'Cancel·lar',
            deleted: ' (Eliminat)',
            chargeStation: 'Ubicacions de càrrega',
            yes: 'Sí',
            no: 'No',
            drivers: 'Conductors',
        },
        placeholder: {
            name: 'Nom',
            selectStatus: "Selecciona l'estat",
            allow_public_access: "Permetre l'accés públic",
            description: 'Descripció',
            access_control_type: "Tipus de control d'accés",
        },
        message: {
            deleteConfirmMesage: 'Estàs segur que el vols eliminar?',
            disableConfirmMesage: 'Estàs segur que el vols deshabilitar?',
            enableConfirmMesage: 'Estàs segur que el vols habilitar?',
        },
        assign: {
            header: 'Ubicacions de càrrega',
            headerModal: 'Ubicacions de càrrega',
            placeholder: {
                name: 'Introdueix el nom',
                address: 'Adreça',
                tags: 'Selecciona les etiquetes',
                postal_code: 'Codi postal',
                power_type: 'Selecciona el tipus de corrent',
            },
            label: {
                add: 'Afegir',
                address: 'Adreça',
                city: 'Ciutat',
                name: 'Nom',
                type: 'Tipus',
                physical_reference: 'Referència física',
                postcode: 'Codi postal',
                action: 'Acció',
                delete: 'Eliminar',
            },
            button: {
                delete: 'Eliminar',
            },
            message: {
                deleteConfirmMesage: 'Estàs segur que el vols eliminar?',
            },
        },
        driverAssign: {
            header: 'Conductors',
            headerModal: 'Conductors',
            placeholder: {
                email: 'Correu electrònic',
                status: 'Estat',
            },
        },
        errors: {
            name: {
                valid: 'Introdueix un nom vàlid',
            },
        },
    },
    accessGroupRequests: {
        title: "Sol·licituds de grup d'accés: ##COMPANY_BRAND_NAME## - Plataforma de serveis eMobility",
        header: "Sol·licituds de grup d'accés",
        columns: {
            name: 'Nom',
            email: 'Correu electrònic',
            federated_account_type: 'Tipus de compte federat',
            requested_access_group: "Grup d'accés sol·licitat",
            requested_date: 'Data de sol·licitud',
            driver_status: 'Estat del conductor',
            request_status: 'Estat de la sol·licitud',
            action: 'Acció',
        },
        button: {
            action: 'Acció',
            search: 'Cercar',
            reset: 'Restablir',
            save: 'Desa',
            cancel: 'Cancel·lar',
        },
        label: {
            review_request: 'Revisar sol·licitud',
            requested_access_group: "Grup d'accés sol·licitat:",
            approve: 'Aprovar',
            decline: 'Rebutjar',
            enterComments: 'Comentaris',
        },
        placeholder: {
            nameEmail: 'Nom/Correu electrònic',
            startDate: "Data d'inici",
            endDate: 'Data de finalització',
            status: "Selecciona l'estat",
            enterComments: 'Introdueix els teus comentaris',
        },
        errors: {
            approveReject: 'Aprova/rebutja aquesta sol·licitud.',
        },
    },
    payByWeb: {
        title: 'Pagar per web: ##COMPANY_BRAND_NAME## - Plataforma de servei eMobility',
        header: 'Pagar per web',
        columns: {
            evse_id: "Identificador d'EVSE",
            status: 'Estat',
            physical_reference: 'Referència física',
            location_name: 'Nom de la ubicació',
            location_address: 'Adreça de la ubicació',
            location_city: 'Ciutat de la ubicació',
            location_postal_code: 'Codi postal de la ubicació',
            pay_by_web_active: 'Pagar per web',
            action: 'Acció',
        },
        button: {
            search: 'Cercar',
            reset: 'Restablir',
            enablePayByWeb: 'Habilitar el pagament per web',
            disabledPayByWeb: 'Deshabilitar el pagament per web',
            submit: 'Enviar',
            cancel: 'Cancel·lar ',
        },
        label: {
            enabled: 'Habilitar',
            disabled: 'Deshabilitar',
            manageUniqueCode: 'Gestionar el codi únic',
            uniqueCode: 'Codi únic',
        },
        message: {
            enableConfirmMesage:
                'Estàs segur que el vols habilitar el pagament per web per a les estacions seleccionades?',
            disableConfirmMesage:
                'Estàs segur que el vols desactivar el pagament per web per a les estacions seleccionades?',
        },
        placeholder: {
            evse_id: "Identificador d'EVSE",
            status: "Selecciona l'estat",
            physical_reference: 'Referència física',
            location_name: 'Nom de la ubicació',
            location_address: 'Adreça de la ubicació',
        },
        errors: {
            unique_code: {
                valid: 'Introdueix un codi únic vàlid',
            },
        },
    },
    driverDebt: {
        title: 'Deute del conductor: ##COMPANY_BRAND_NAME## - Plataforma de servei eMobility',
        header: 'Deute del conductor',
        button: {
            download: 'Descarregar',
            strikeOneLetter: 'Carta de primera advertència',
            strikeTwoLetter: 'Carta de segona advertència',
            generateStrikeOneLetters: 'Generar cartes de primera advertència',
            generateStrikeTwoLetters: 'Generar cartes de egona advertència',
            runHistory: "Generar cartes d'advertència - Històric d'execució",
            pastLetters: 'Cartes anteriors',
            regenerateLetters: 'Regenerar cartes',
            refreshPastLetters: 'Actualitzar cartes anteriors',
        },
        label: {
            pastLetters: 'Cartes anteriors',
            inProgress: '(en curs)',
            noDataFound: "No s'han trobat dades.",
            dynamicFields: 'Camps dinàmics',
            clickToCopy: '(fes clic per copiar la notació)',
            driverName: 'Nom del conductor',
            driverDebt: 'Deute del conductor',
            debtAge: 'Antiguitat del deute',
            driverEmail: 'Correu electrònic del conductor',
            driverAddress: 'Adreça del conductor',
            date: 'Data',
            clickToCopyTooltip: 'Fes clic per copiar',
            regenerate: 'Regenerar',
            regenerateLetters: 'Regenerar cartes',
            letterTemplate: 'Plantilla de carta',
            cancel: 'Cancel·lar ',
            reportGenerationInProgress: "(Generació d'informes en curs)",
            copyDriverIds: 'Fes clic per copiar els identificadors dels conductors',
        },
        columns: {
            run: "Número d'execució",
            driverIDs: "Identificador de conductors elegibles en aquest punt de l'execució",
            runTimestamp: 'Executa la marca horària',
            strikeType: "Tipus d'advertència",
            initiatedByUser: "Usuari que va iniciar l'execució",
            regenerate: 'Regenerar',
            action: 'Acció',
            relatedRun: "Núm. d'execució relacionat",
            date: 'Data',
            file: 'Fitxer',
            templateUsed: 'Plantilla utilitzada',
            generatedBy: 'Generada per',
        },
        placeholder: {
            strikeOneLetter: 'Seleccionar carta de primera advertència',
            strikeTwoLetter: 'Seleccionar carta de segona advertència',
        },
    },
    fleetAccessGroups: {
        title: "Sol·licituds de grup d'accés: ##COMPANY_BRAND_NAME## - Plataforma de serveis eMobility",
    },
    emailLogs: {
        title: 'Registres de correus electrònics: ##COMPANY_BRAND_NAME## - Plataforma de servei eMobility',
        header: 'Registres de correus electrònics',
        columns: {
            recipient: 'Destinatari',
            subject: 'Assumpte',
            deliveryStatus: "Estat de l'entrega",
            errorMessage: "Missatge d'error",
            createdDate: 'Data de creació',
        },
        label: {
            viewError: 'Veure error',
        },
        placeholder: {
            recipient: 'Destinatari',
            subject: 'Assumpte',
            deliveryStatus: "Estat de l'entrega",
            errorMessage: "Missatge d'error",
            startDate: "Data d'inici",
            endDate: 'Data de finalització',
        },
    },
    alerts: {
        title: "Registres d'errors OCPI: ##COMPANY_BRAND_NAME## - Plataforma de servei eMobility",
        header: "Registres d'errors OCPI",
        columns: {
            api: 'url',
            api_call_type: 'Tipus de trucada API',
            api_request_type: 'Tipus de sol·licitud',
            response_code: 'Codi de resposta',
            error_message: "Missatge d'error",
            alert_type: "Tipus d'alerta",
            created_date: 'Data de creació',
            request_body: 'Cos de la sol·licitud',
            response_body: 'Cos de la resposta',
        },
        placeholder: {
            api: 'url',
            alert_type: "Tipus d'alerta",
            startDate: "Data d'inici",
            endDate: 'Data de finalització',
        },
        button: {
            search: 'Cercar',
            reset: 'Restablir',
        },
        label: {
            viewDetails: 'Veure detalls',
            errorLogDetails: "Detalls del registre d'errors OCPI",
        },
    },
    SubscriptionSetting: {
        title: 'Subscripcions Premium: ##COMPANY_BRAND_NAME## - Plataforma de servei eMobility',
        header: 'Subscripcions Premium',
        manageSubscription: 'Gestionar la subscripció Premium',
        label: {
            subscription_type: 'Tipus de subscripció',
            subscription_amount: 'Import de la subscripció',
            free_subscription_duration: 'Durada de la subscripció gratuïta',
            created_date: 'Data de creació',
            status: 'Estat',
            action: 'Acció',
            enabled: 'Habilitar',
            disabled: 'Deshabilitar',
            maximum_routing_call: "Trucades màximes d'encaminament (per mes)",
            additional_volts_per_kwh: 'Recompenses addicionals dels volt(s)/kWh',
            name: 'Nom',
            description: 'Descripció',
            subscriptionImage: 'Imatge de subscripció Premium',
            exportSubscribersList: 'Exportar la llista de subscriptors',
            downloadSubscribersList: 'Descarregar la llista de subscriptors',
        },
        placeholder: {
            subscription_amount: 'Import de la subscripció',
            free_subscription_duration: 'Durada de la subscripció gratuïta (Dies)',
            maximum_routing_call: "Trucades màximes d'encaminament",
            name: 'Nom',
            status: "Selecciona l'estat",
            subscriptionType: 'Seleccionar tipus de subscripció',
            subscriptionImage: 'Seleccionar imatge de subscripció Premium',
        },
        button: {
            action: 'Acció',
            disable: 'Deshabilitar',
            enable: 'Habilitar',
            edit: 'Editar',
            back: 'Enrere',
            save: 'Desa',
            cancel: 'Cancel·lar',
            enableDisable: 'Activa/Desactiva la subscripció',
            add: 'Afegir',
            search: 'Cercar',
            reset: 'Restablir',
        },
        errors: {
            amount: {
                moreThan: "L'import ha de ser superior a 1",
                lessThan: "L'import ha de ser inferior a 100",
                number: "L'import ha de ser un número",
            },
            duration: {
                moreThan: 'La durada ha de ser superior a 1',
                lessThan: 'La durada ha de ser inferior a 180',
            },
            maxRoutingCall: {
                moreThan: "El valor màxim de trucades d'encaminament ha de ser superior a 1",
                lessThan: "El valor màxim de trucades d'encaminament ha de ser inferior a 1000",
            },
            additionalVolts: {
                lessThan: 'El valor ha de ser inferior o igual a 5',
                number: 'El valor ha de ser un número',
            },
        },
        message: {
            enableFromConfig:
                'Per habilitar una subscripció Premium, primer configura "Habilita la subscripció Premium" com a "Verdader" a Opcions > Configuracions',
            disableConfirmMessage:
                'Advertència: Al desactivar la Subscripció Premium, es cancel·laran totes les renovacions automàtiques associades al compte del Conductor. Estàs segur que el vols deshabilitar?',
            enableConfirmMessage: 'Estàs segur que el vols habilitar?',
        },
    },
    advertisingDevices: {
        title: 'Dispositius publicitaris: ##COMPANY_BRAND_NAME## - Plataforma de servei eMobility',
        header: 'Dispositius publicitaris',
        label: {
            enabled: 'Habilitat ',
            disabled: 'Deshabilitat',
            device_name: 'Nom',
            device_id: 'Identificador del dispositiu',
            postal_code: 'Codi postal',
            charge_station: 'Estació de càrrega',
            screen_size: 'Mida de la pantalla',
            created_date: 'Data de creació',
            status: 'Estat',
            action: 'Acció',
            delete: 'Eliminar',
            operational: 'Operatiu',
        },
        button: {
            action: 'Acció',
            edit: 'Editar',
            delete: 'Eliminar',
            enabled: 'Habilitar',
            disabled: 'Deshabilitar',
            add: 'Afegir',
            reset: 'Restablir',
            search: 'Cercar',
            back: 'Enrere',
            save: 'Desa',
            cancel: 'Cancel·lar',
            assignVideos: 'Assignar vídeos',
            yes: 'Sí',
            no: 'No',
            regenerateS3File: 'Regenerar fitxer S3',
            mediaTerminalLogs: 'Registres terminals multimèdia',
        },
        placeholder: {
            device_name: 'Nom del dispositiu',
            postal_code: 'Codi postal',
            charge_station: 'Estació de càrrega',
            selectStatus: "Selecciona l'estat",
            screen_size: 'Mida de la pantalla',
        },
        message: {
            deleteConfirmMesage: 'Estàs segur que el vols eliminar?',
            enableConfirmMesage: 'Estàs segur que el vols habilitar?',
            disableConfirmMesage: 'Estàs segur que el vols deshabilitar?',
        },
        insert: {
            header: 'Gestionar dispositiu publicitari',
            placeholder: {
                device_name: 'Nom del dispositiu',
                device_id: 'Identificador del dispositiu',
                charge_station: 'Estació de càrrega',
                screen_size: 'Mida de la pantalla',
            },
            label: {
                device_name: 'Nom del dispositiu',
                device_id: 'Identificador del dispositiu',
                charge_station: 'Estació de càrrega',
                screen_size: 'Mida de la pantalla',
            },
            errors: {
                common: 'Alguna cosa ha anat malament, intenta-ho de nou.',
                name: {
                    valid: 'Introdueix un nom vàlid',
                },
                device_id: {
                    valid: 'Introdueix un identificador de dispositiu vàlid',
                    min: "L'identificador del dispositiu ha de tenir com a mínim 6 caràcters",
                },
            },
        },
        assignVideos: {
            header: 'Vídeos',
            headerModal: 'Vídeos',
            label: {
                action: 'Acció',
                delete: 'Eliminar',
            },
            placeholder: {
                file_name: "Nom de l'arxiu",
                description: 'Descripció',
            },
            message: {
                deleteConfirmMesage: 'Estàs segur que el vols eliminar?',
            },
        },
    },
    advertisingVideos: {
        title: 'Vídeos publicitaris: ##COMPANY_BRAND_NAME## - Plataforma de servei eMobility',
        header: 'Vídeos publicitaris',
        label: {
            file_name: "Nom de l'arxiu",
            description: 'Descripció',
            operational_start_date: "Data d'inici operativa",
            operational_end_date: 'Data de finalització operativa',
            created_date: 'Data de creació',
            status: 'Estat',
            action: 'Acció',
            delete: 'Eliminar',
            reviewVideo: 'Revisa el vídeo',
            approve: 'Aprovar',
            reject: 'Rebutjar',
            videoUpload: 'Vídeo',
            comments: 'Comentaris',
        },
        button: {
            action: 'Acció',
            edit: 'Editar',
            delete: 'Eliminar',
            enabled: 'Habilitar',
            disabled: 'Deshabilitar',
            add: 'Afegir',
            reset: 'Restablir',
            search: 'Cercar',
            back: 'Enrere',
            save: 'Desa',
            cancel: 'Cancel·lar ',
            reviewVideo: 'Revisa el vídeo',
            downloadVideo: 'Descarregar el vídeo',
            assignDevice: 'Assignar dispositius',
        },
        placeholder: {
            file_name: "Nom de l'arxiu",
            description: 'Descripció',
            start_date: "Data d'inici operativa",
            end_date: 'Data de finalització operativa',
            selectStatus: "Selecciona l'estat",
            videoUpload: 'Vídeo',
            enterComments: 'Introdueix els teus comentaris',
        },
        message: {
            deleteConfirmMesage: 'Estàs segur que el vols eliminar?',
        },
        insert: {
            header: 'Gestionar vídeo publicitari',
            placeholder: {
                description: 'Descripció',
                operational_start_date: "Data d'inici operativa",
                operational_end_date: 'Data de finalització operativa',
            },
            label: {
                description: 'Descripció',
                operational_start_date: "Data d'inici operativa",
                operational_end_date: 'Data de finalització operativa',
            },
        },
        errors: {
            status: {
                message: {
                    selectApprovalOrReject: 'Aprova/rebutja aquesta sol·licitud.',
                },
            },
            name: {
                valid: 'Introdueix un nom vàlid',
            },
            file_name: {
                fileType: "Es poden carregar arxius amb extensió '.mp4', '.flv', '.wmv', '.mpeg', '.avi', '.3gp'",
                uploadError: "Error en pujar l'arxiu de vídeo",
                required: 'Es requereix un arxiu de vídeo',
                fileNameLength: "Es permeten com a màxim 15 caràcters per al nom de l'arxiu",
            },
            file_size: "La mida màxima de càrrega de l'arxiu és",
        },
        assignDevices: {
            header: 'Dispositius',
            headerModal: 'Dispositius',
            label: {
                action: 'Acció',
                delete: 'Eliminar',
            },
            placeholder: {
                device_name: 'Nom del dispositiu',
                device_id: 'Identificador del dispositiu',
                status: 'Estat',
            },
            message: {
                deleteConfirmMesage: 'Estàs segur que el vols eliminar?',
            },
        },
    },
    advertisingCredentials: {
        title: 'Credencials publicitàries: ##COMPANY_BRAND_NAME## - Plataforma de servei eMobility',
        header: 'Credencials publicitàries',
        manageCredentials: 'Gestionar credencials publicitàries',
        label: {
            bucket_name: 'Nom del contenidor',
            region_name: 'Nom de la regió',
            download_access_key: "Descarregar la clau d'accés",
            download_secret_key: 'Descarregar la clau secreta',
            upload_access_key: "Pujar la clau d'accés",
            upload_secret_key: 'Pujar la clau secreta',
            download_info_object_name: "Nom de l'objecte de descàrrega d'informació",
            upload_path: 'Ruta de pujada',
            dialog_password: 'Contrasenya del diàleg',
            expect_bucket_name: 'Espera el nom del contenidor',
            expect_region_name: 'Espera el nom de la regió',
            expect_download_access_key: "Espera la clau d'accés de descàrrega",
            expect_download_secret_key: 'Espera la clau secreta de descàrrega',
            version_code: 'Codi de versió',
            download_url: 'URL de descàrrega',
            prompt: 'Pregunta',
            remarks: 'Observacions',
            modified_by: 'Modificat per',
            modified_date: 'Data de modificació',
            status: 'Estat',
            action: 'Acció',
            enabled: 'Habilitar',
            disabled: 'Deshabilitar',
        },
        button: {
            action: 'Acció',
            disable: 'Deshabilitar',
            enable: 'Habilitar',
            edit: 'Editar',
            back: 'Enrere',
            save: 'Desa',
            cancel: 'Cancel·lar',
        },
    },
    organisationInvoices: {
        title: "Factures d'organització: ##COMPANY_BRAND_NAME## - Plataforma de servei eMobility",
        header: "Factures d'organització",
        label: {
            name: 'Organització',
            invoice_id: 'Identificador de la factura',
            invoice_value: 'Valor de la factura',
            invoice_date: 'Data de la factura',
            action: 'Acció',
            undo: 'Desfer',
            undoPayment: 'Desfer pagament',
            disputed: 'Disputada',
            adjustAmount: 'Ajustar el valor de la factura ',
            paid_value: 'Valor pagat',
            outstanding: 'Pendent',
            status: 'Estat',
            comments: 'Comentaris',
            original_value: 'Valor original',
        },
        placeholder: {
            name: 'Nom',
            start_date: "Data d'inici",
            end_date: 'Data de finalització',
            status: 'Estat',
            organisation: "Selecciona l'organització",
        },
        button: {
            search: 'Cercar',
            reset: 'Restablir',
            action: 'Acció',
            pay: 'Pagar',
            partPay: 'Pagar parcialment',
            undo: 'Desfer',
            disputed: 'Disputada',
            adjustValue: 'Ajustar el valor de la factura',
        },
        errors: {
            amount: {
                moreThan: "L'import ha de ser superior a 0",
                maxValue: "Valor màxim assolit per a l'import",
                notZero: "L'import ha de ser més gran/més petit que 0",
                minValue: "Valor mínim assolit per a l'import",
                number: "L'import ha de ser un número",
            },
            organisation: {
                required: "Selecciona l'organització",
            },
        },
        message: {
            undoConfirmMessage:
                "Estàs segur que vols eliminar el valor de pagament i establir l'estat a “Pendent” per a aquesta factura?",
            disputedConfirmMessage: "Estàs segur que vols establir l'estat com a “Disputada” per a aquesta factura?",
        },
        payModal: {
            header: 'Pagar',
            partPayHeader: 'Pagar parcialment',
            label: {
                amount: 'Import',
                date_paid: 'Data de pagament',
                comments: 'Comentaris',
            },
            placeholder: {
                amount: "Introdueix l'import",
                date_paid: 'Introdueix la data de pagament',
                comments: 'Introdueix comentaris',
            },
            button: {
                accept: 'Acceptar',
                send_for_approval: 'Enviar per a aprovació',
                cancel: 'Cancel·lar ',
                submit: 'Enviar',
            },
        },
    },
    mediaTerminalLogs: {
        title: 'Registres terminals multimèdia: ##COMPANY_BRAND_NAME## - Plataforma de servei eMobility',
        header: 'Registres terminals multimèdia',
        label: {
            file_name: "Nom de l'arxiu",
            date_played: 'Data de reproducció',
            play_time: 'Temps de reproducció',
            start_time: "Hora d'inici",
        },
        placeholder: {
            fileName: "Nom de l'arxiu",
            startDate: "Data d'inici",
            endDate: 'Data de finalització',
        },
    },
    fleetDriverSpendHistory: {
        title: 'Històric de límits de despesa: ##COMPANY_BRAND_NAME## - Plataforma de servei eMobility',
        header: 'Històric de límits de despesa',
        label: {
            enabled: 'Habilitat ',
            disabled: 'Deshabilitat',
            name: 'Nom del conductor',
            email: 'Correu electrònic del conductor',
            type: 'Tipus de llindar',
            spend_limit_exceed_date: 'Data de superació del límit de despesa',
            status: 'Estat del conductor',
            action: 'Acció',
            export: 'Exportar',
            onStop: 'En aturar',
            cancelOnStop: 'Cancel·la en aturar',
        },
        button: {
            disable: 'Deshabilitar',
            enable: 'Habilitar',
            search: 'Cercar',
            reset: 'Restablir',
            yes: 'Sí',
            no: 'No',
            back: 'Enrere',
        },
        placeholder: {
            name: 'Nom del conductor',
            email: 'Correu electrònic del conductor',
            status: "Selecciona l'estat del conductor",
            dateFrom: "Data d'inici de superació del límit",
            dateTo: 'Data de finalització de superació del límit',
            type: 'Selecciona el tipus de llindar',
        },
        message: {
            noDataToExport: 'No hi ha dades per exportar.',
            cancelOnStopConfirmation: 'Estàs segur que vols cancel·lar en aturar per aquest conductor?',
        },
    },
    driverDebtorLetters: {
        title: 'Cartes de deutor del conductor: ##COMPANY_BRAND_NAME## - Plataforma de servei eMobility',
        header: 'Cartes de deutor del conductor',
        manageDriverDebtorLetter: 'Gestionar carta de deutor del conductor',
        label: {
            reportType: "Tipus d'informe",
            defaultLetter: 'Plantilla per defecte de carta de deutor',
            content: 'Contingut',
            enabled: 'Habilitat ',
            disabled: 'Deshabilitat',
            created_date: 'Data de creació',
            status: 'Estat',
            action: 'Acció',
            delete: 'Eliminar',
            dynamicFields: 'Camps dinàmics',
            copyNotation: '(Feu clic per copiar la notació)',
            clickToCopy: 'Fes clic per copiar',
            driverName: ' â€¢ Nom del conductor',
            driverDebt: 'â€¢ Deute del conductor',
            debtAge: 'â€¢ Antiguitat del deute',
            driverEmail: 'â€¢ Correu electrònic del conductor',
            driverAddress: 'â€¢ Adreça del conductor',
            date: 'â€¢ Data',
            uniqueReference: 'â€¢ Referència única',
            useStandardTemplate: 'Utilitza la plantilla estàndard',
        },
        column: {
            defaultLetter: 'Carta per defecte',
        },
        button: {
            setDefaultLetter: 'Establir com a predeterminat',
            enable: 'Habilitar',
            disable: 'Deshabilitar',
            edit: 'Editar',
            delete: 'Eliminar',
            createDuplicate: 'Crear duplicat',
            save: 'Desa',
            cancel: 'Cancel·lar ',
            preview: 'Visualització prèvia',
        },
        message: {
            setDefaultConfirmMesage: 'Estàs segur que vols establir aquesta Carta del deutor com a predeterminada?',
            enableConfirmMesage: 'Estàs segur que el vols habilitar?',
            disableConfirmMesage: 'Estàs segur que el vols deshabilitar?',
            deleteConfirmMesage: 'Estàs segur que el vols eliminar?',
        },
        error: {
            emptyContent: 'Proporciona contingut per previsualitzar la Plantilla de la carta',
            common: 'Hi ha hagut un error processant la teva sol·licitud. Prova-ho més tard.  ',
            supportedDynamicField1: 'Aquests camps dinàmics',
            supportedDynamicField2: 'només són compatibles per a la carta del deutor.',
        },
    },
    driverSubscriptions: {
        title: 'Subscripcions Premium del conductor: ##COMPANY_BRAND_NAME## - Plataforma de servei eMobility',
        header: 'Subscripcions Premium',
        label: {
            subscriptionType: 'Tipus de subscripció',
            subscriptionStartDate: "Data d'inici de la subscripció",
            subscriptionStatus: 'Estat de la subscripció',
            renewalOrExpiryDate: 'Data de renovació/caducitat',
            voltsCredited: 'Volts acreditats',
            journeysPlanned: 'Viatges planificats',
            active: 'Actiu',
            cancelled: 'Cancel·lat',
            action: 'Acció',
            cancel: 'Cancel·lar ',
            cancelSubscription: 'Subscripció cancel·lada',
            terminate: 'Donar de baixa',
            terminateSubscription: 'Donar de baixa la subscripció',
            freeTrial: 'Prova gratuïta',
            name: 'Nom',
            promotion: 'Promoció',
        },
        message: {
            cancelConfirmMessage:
                'Estàs segur que vols cancel·lar la subscripció per a aquest usuari? Això cancel·larà la propera renovació automàtica de la subscripció.',
            terminateConfirmMessage:
                "Estàs segur que vols donar de baixa la subscripció per a aquest usuari? Això cancel·larà la propera renovació automàtica i aturarà tots els avantatges d'aquesta subscripció immediatament.",
            terminateConfirmMessageWithoutRenew:
                "Estàs segur que vols donar de baixa la subscripció per a aquest usuari? Això aturarà tots els avantatges d'aquesta subscripció immediatament.",
        },
    },
    advertisingDropDownDefaultmessage: "Introdueix com a mínim 3 caràcters de llocs per mostrar la llista d'estacions",
    rfidcardDropDownDefaultMessage: 'Introdueix com a mínim 3 caràcters per mostrar la llista de conductors/vehicles',
    chargeStationMapDropDownDefaultMessage:
        "Introdueix com a mínim 3 caràcters d'estació de càrrega per mostrar les estacions de càrrega",
    startChargePageDropDownDefaultMessage: 'Introdueix caràcters de llocs per mostrar la llista de llocs',
    groupGridDropDownDefaultMessage: 'Introdueix com a mínim 3 caràcters per mostrar la llista de conductors/vehicles',
    organisationdashBoardDefaultMessage:
        'Introdueix com a mínim 3 caràcters per mostrar la llista de conductors/vehicles',
    rfidAssigncardDefaultDropDownMessage:
        'Introdueix com a mínim 3 caràcters del correu electrònic del conductor per mostrar la llista de conductors',
    tariffDropDownDefaultMessage: ' Introduïu un mínim de 3 caràcters de la tarifa per mostrar la llista de tarifes',
    limitExceedAddressError: "No es pot trobar l'adreça en aquest moment",
    continueTypingSearch: 'Continua escrivint per corregir la cerca',
    noFileChosen: 'Cap arxiu seleccionat',
    ChooseFile: 'Tria un arxiu',
    noOptions: 'Sense opcions',
    requiredField: 'El fitxer és un camp obligatori',
    removeImage: 'Elimina la imatge',
    help: 'Ajuda',
    editor: {
        bold: 'Negreta',
        italic: 'Cursiva',
        underline: 'Subratllat',
        strikeThrough: 'Barrat',
        monospace: 'Monoespai',
        superscript: 'Superíndex',
        subscript: 'Subíndex',
        blockType: 'Tipus de bloc',
        fontSize: 'Mida de la font',
        font: 'Font',
        unordered: 'Sense ordre',
        ordered: 'Ordenat',
        indent: 'Sagnia',
        outdent: 'Desfer sagnia',
        left: 'Esquerra',
        right: 'Dreta',
        center: 'Centre',
        justify: 'Justificar',
        colorPicker: 'Selector de color',
        link: 'Enllaç',
        unlink: "Treure l'enllaç",
        embedded: 'Incrustat',
        emoji: 'Emoji',
        remove: 'Eliminar',
        undo: 'Desfer',
        redo: 'Refés',
        image: 'Imatge',
    },
    map: {
        zoomIn: 'Ampliar',
        zoomOut: 'Allunyar',
    },
    InstaVolt: '##COMPANY_BRAND_NAME##',
    apply: 'Aplicar',
    cancel: 'Cancel·lar ',
    noDataFound: "No s'ha trobat cap dada",
    globalService: {
        title: 'Registre de serveis globals: ##COMPANY_BRAND_NAME## - Plataforma de servei eMobility',
        status: {
            pending:
                "Per comunicar amb els serveis globals, introdueix la informació següent. Fent clic al botó 'Registrar', podràs configurar la comunicació.",
            registered:
                'La plataforma EMSP pot comunicar-se ara mateix amb els serveis globals. Si tens problemes de comunicació, introdueix la informació següent i fes clic al botó “Tornar a registrar”.',
        },
        insert: {
            url: 'URL',
            handshakeToken: 'Fitxa de captura de mans',
        },
        placeholder: {
            url: 'URL',
            handshakeToken: 'Fitxa de captura de mans',
        },
        label: {
            note: 'Nota',
            noteValue:
                "S'ha de proporcionar la “fitxa de captura de mans” cada vegada que es configura la comunicació amb els serveis globals. Per identificar la “fitxa de captura de mans”, posa't en contacte amb l'administrador del sistema.",
            rfidSync: 'Sincronització RFID',
        },
        button: {
            register: 'Registrar',
            reRegister: 'Tornar a registrar',
        },
        error: {
            errorWhileCreatingGlobalService: 'Error en crear el servei global.',
            errorWhileUpdatingGlobalService: 'Error en actualitzar el servei global',
        },
        endpointsTable: {
            header: 'Punt final del servei global',
            column: {
                identifer: 'Identificador',
                httpMethod: 'Mètode HTTP',
                url: 'Url',
            },
        },
    },
    price_breakdown_details: {
        detailed_breakup: 'Desglossament detallat',
        total_cost: 'Cost total',
        conversion_rate: 'Taxa de conversió',
        totalNetCost: 'Cost Net Total',
        total_parking_cost: "Cost Total d'Estacionament",
        total_energy_cost: "Cost Total d'Energia",
        total_fixed_cost: 'Cost Fix Total',
        total_time_cost: 'Cost Total de Temps de Càrrega',
    },
    SubscriptionImages: {
        title: 'Imatges de subscripció Premium',
        manageSubscriptionImage: 'Gestionar imatge de subscripció Premium',
        label: {
            name: 'Nom',
            description: 'Descripció',
            action: 'Acció',
            delete: 'Eliminar',
            image: 'Imatge',
            language: 'Idioma',
        },
        button: {
            edit: 'Editar',
            search: 'Cercar',
            reset: 'Restablir',
            add: 'Afegir',
        },
        message: {
            deleteConfirmMesage: 'Estàs segur que el vols eliminar?',
        },
        errors: {
            insertEnglishLanguageImage: "Carrega una imatge per a l'idioma anglès",
            required: 'Es requereix una imatge.',
        },
    },
    driverPaymentCards: {
        title: 'Targetes de pagament del conductor: InstaVolt - Plataforma de servei eMobility',
        header: 'Targetes de pagament',
        label: {},
    },
};
